"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4409],{

/***/ 5706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ InputError; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Form/InputError/InputErrorStyle.ts




var InputErrorStyle = es/* StyleSheet.create */.mM.create({
  inputError: {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption3 */.Nv.caption3,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    color: colorStyle/* accentColor.alertColor */.z.alertColor,
    display: "inline-block",
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " 0"),
    // 左右のpaddingは不要
    margin: 0
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Form/InputError/InputError.tsx





var InputErrorComponent = function InputErrorComponent(props) {
  var meta = props.meta;
  var error = meta.touched && meta.error;

  if (props.isIndependent) {
    error = meta.error;
  }

  var submitError = meta.submitFailed && meta.submitError;

  if (error) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      className: (0,es/* css */.iv)(InputErrorStyle.inputError, props.styles),
      children: meta.error
    });
  }

  if (submitError) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      className: (0,es/* css */.iv)(InputErrorStyle.inputError, props.styles),
      children: meta.submitError
    });
  }

  return null;
};

var InputError = /*#__PURE__*/react.memo(InputErrorComponent);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Form/InputError/index.ts


/***/ }),

/***/ 14907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U2": function() { return /* binding */ RangeSlider; },
  "q0": function() { return /* binding */ RangeSliderOnChangeLeft; }
});

// UNUSED EXPORTS: RangeSliderOnChangeRight

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/RangeSliderStyle.ts
var RangeSliderStyle = __webpack_require__(84543);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/RangeSliderHandle.tsx








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var RangeSliderHandle = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(RangeSliderHandle, _React$Component);

  var _super = _createSuper(RangeSliderHandle);

  function RangeSliderHandle() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, RangeSliderHandle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "selfElm", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onMouseDown", function (e) {
      document.addEventListener("mousemove", _this.onMouseMove);
      document.addEventListener("mouseup", _this.onMouseUp);
      e.preventDefault();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onMouseUp", function (e) {
      document.removeEventListener("mousemove", _this.onMouseMove);
      document.removeEventListener("mouseup", _this.onMouseUp);

      if (_this.props.onClickEnd) {
        _this.props.onClickEnd();
      }

      e.preventDefault();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onMouseMove", function (e) {
      _this.props.onMove(e.clientX);

      e.preventDefault();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onTouchStart", function (e) {
      e.preventDefault();
      document.addEventListener("touchmove", _this.onTouchMove, {
        passive: false
      });
      document.addEventListener("touchend", _this.onTouchEnd, {
        passive: false
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onTouchMove", function (e) {
      if (e.cancelable) {
        e.preventDefault();
      }

      _this.props.onMove(e.touches[0].clientX);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onTouchEnd", function () {
      document.removeEventListener("touchmove", _this.onTouchMove);
      document.removeEventListener("touchend", _this.onTouchEnd);

      if (_this.props.onClickEnd) {
        _this.props.onClickEnd();
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "setSelfElement", function (node) {
      if (node) {
        _this.selfElm = node;

        _this.selfElm.addEventListener("mousedown", _this.onMouseDown, {
          passive: false
        });

        _this.selfElm.addEventListener("touchstart", _this.onTouchStart, {
          passive: false
        });
      }
    });

    return _this;
  }

  (0,createClass/* default */.Z)(RangeSliderHandle, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.selfElm) {
        this.selfElm.removeEventListener("mousedown", this.onMouseDown);
        this.selfElm.removeEventListener("touchstart", this.onTouchStart);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          position = _this$props.position,
          styles = _this$props.styles;
      var blockStyle = position === "left" ? [RangeSliderStyle/* RangeSliderStyle.handle */.e.handle, RangeSliderStyle/* RangeSliderStyle.handleLeft */.e.handleLeft] : RangeSliderStyle/* RangeSliderStyle.handle */.e.handle;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,es/* css */.iv)(blockStyle, styles),
        style: {
          left: "".concat(this.props.x * 100, "%")
        },
        ref: this.setSelfElement
      });
    }
  }]);

  return RangeSliderHandle;
}(react.Component);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/RangeSlider.tsx








function RangeSlider_createSuper(Derived) { var hasNativeReflectConstruct = RangeSlider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function RangeSlider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var RangeSliderOnChangeLeft = "RangeSliderOnChangeLeft";
var RangeSliderOnChangeRight = "RangeSliderOnChangeRight";
var RangeSlider = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(RangeSlider, _React$Component);

  var _super = RangeSlider_createSuper(RangeSlider);

  function RangeSlider() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, RangeSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
      x_start: 0,
      x_end: 0,
      x_left: 0,
      x_right: 1
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "innerElm", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "setInnerElement", function (node) {
      if (node) {
        _this.innerElm = node;
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onMoveLeft", function (x) {
      var bounds = _this.innerElm.getBoundingClientRect();

      var relativeX = x - bounds.left;
      var posRatio = (relativeX - _this.state.x_start) / (_this.state.x_end - _this.state.x_start);
      var maxPos = _this.state.x_right - 1 / _this.props.dataNum;
      posRatio = posRatio > 0 ? posRatio : 0;
      posRatio = posRatio < maxPos ? posRatio : maxPos;

      _this.setState({
        x_left: posRatio
      });

      _this.props.onChange(RangeSliderOnChangeLeft, posRatio);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onMoveRight", function (x) {
      var bounds = _this.innerElm.getBoundingClientRect();

      var relativeX = x - bounds.left;
      var posRatio = (relativeX - _this.state.x_start) / (_this.state.x_end - _this.state.x_start);
      var minPos = _this.state.x_left + 1 / _this.props.dataNum;
      posRatio = posRatio > minPos ? posRatio : minPos;
      posRatio = posRatio < 1 ? posRatio : 0.9999; // 1だと配列数の最大を超えるため制限している

      _this.setState({
        x_right: posRatio
      });

      _this.props.onChange(RangeSliderOnChangeRight, posRatio);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onResizeWindow", function () {
      _this.getSliderPosition();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onClickEndLeft", function () {
      if (_this.props.onClickEnd) {
        _this.props.onClickEnd(RangeSliderOnChangeLeft);
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onClickEndRight", function () {
      if (_this.props.onClickEnd) {
        _this.props.onClickEnd(RangeSliderOnChangeRight);
      }
    });

    return _this;
  }

  (0,createClass/* default */.Z)(RangeSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        x_left: this.props.initialLeft,
        x_right: this.props.initialRight
      }); // css適用後にサイズ取得するために遅延させる

      setTimeout(function () {
        _this2.getSliderPosition();

        window.addEventListener("resize", _this2.onResizeWindow);
      }, 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.initialLeft !== this.props.initialLeft || prevProps.initialRight !== this.props.initialRight) {
        this.setState({
          x_left: prevProps.initialLeft !== this.props.initialLeft ? this.props.initialLeft : this.state.x_left,
          x_right: prevProps.initialRight !== this.props.initialRight ? this.props.initialRight : this.state.x_right
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.innerElm = null;
      window.removeEventListener("resize", this.onResizeWindow);
    }
  }, {
    key: "getSliderPosition",
    value: function getSliderPosition() {
      if (this.innerElm) {
        this.setState({
          x_start: 0,
          x_end: this.innerElm.clientWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$styles = this.props.styles,
          styles = _this$props$styles === void 0 ? {} : _this$props$styles;
      var block = styles.block,
          bar = styles.bar,
          handleLeft = styles.handleLeft,
          handleRight = styles.handleRight;
      var barWidthPer = this.state.x_right - this.state.x_left;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,es/* css */.iv)(RangeSliderStyle/* RangeSliderStyle.block */.e.block, block),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,es/* css */.iv)(RangeSliderStyle/* RangeSliderStyle.inner */.e.inner),
          ref: this.setInnerElement,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: (0,es/* css */.iv)(RangeSliderStyle/* RangeSliderStyle.bar */.e.bar, bar),
            style: {
              transform: "translateX(".concat(this.state.x_left * 100, "%) scaleX(").concat(barWidthPer, ")")
            }
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeSliderHandle, {
            styles: [handleLeft],
            x: this.state.x_left,
            position: "left",
            onMove: this.onMoveLeft,
            onClickEnd: this.onClickEndLeft
          }, "left"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeSliderHandle, {
            styles: [handleRight],
            x: this.state.x_right,
            position: "right",
            onMove: this.onMoveRight,
            onClickEnd: this.onClickEndRight
          }, "right")]
        })
      });
    }
  }]);

  return RangeSlider;
}(react.Component);

/***/ }),

/***/ 84543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ RangeSliderStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var _styles_base_shadowStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78698);




var RangeSliderStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    position: "relative",
    height: "40px"
  },
  inner: {
    position: "relative",
    height: "100%",
    width: "calc(100% - (".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom2x */ .D.atom2x, " * 2))"),
    margin: "0 auto",
    ":before": {
      content: '""',
      width: "calc(100% + (".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom2x */ .D.atom2x, " * 2))"),
      height: "4px",
      position: "absolute",
      top: "50%",
      left: "-".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom2x */ .D.atom2x),
      marginTop: "-2px",
      background: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_1__/* .textColor.disabledColor */ .zP.disabledColor
    }
  },
  innerOneHandle: {
    position: "relative",
    height: "100%",
    width: "calc(100% - (".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom2x */ .D.atom2x, "))"),
    margin: "0 auto 0 0",
    ":before": {
      content: '""',
      width: "calc(100% + (".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom2x */ .D.atom2x, "))"),
      height: "4px",
      position: "absolute",
      top: "50%",
      left: 0,
      marginTop: "-2px",
      background: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_1__/* .textColor.disabledColor */ .zP.disabledColor
    }
  },
  bar: {
    position: "absolute",
    top: "50%",
    height: "4px",
    background: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_1__/* .accentColor.primaryColor2 */ .z.primaryColor2,
    width: "100%",
    marginTop: "-2px",
    transformOrigin: "left"
  },
  handleBlock: {
    width: "40px",
    height: "40px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    marginLeft: "-20px"
  },
  handleBlockLeft: {
    width: "50px",
    marginLeft: "-30px",
    padding: "0 0 0 10px",
    boxSizing: "border-box"
  },
  handle: {
    width: "40px",
    height: "40px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    marginLeft: "-20px",
    borderRadius: "50%",
    background: "#fff",
    border: "1px solid ".concat(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_1__/* .borderColor.shadowColor */ .tv.shadowColor),
    boxShadow: _styles_base_shadowStyle__WEBPACK_IMPORTED_MODULE_3__/* .boxShadow["interface"] */ .W["interface"],
    userSelect: "none"
  },
  handleLeft: {
    ":before": {
      content: '""',
      width: "10px",
      height: "100%",
      position: "absolute",
      top: 0,
      left: "-10px"
    }
  },
  error: {
    borderBottomColor: "".concat(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_1__/* .accentColor.alertColor */ .z.alertColor)
  }
});

/***/ }),

/***/ 81432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Label; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Label/LabelStyle.ts



var LabelStyle = es/* StyleSheet.create */.mM.create({
  label: {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption1 */.Nv.caption1,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    display: "block",
    whiteSpace: "nowrap",
    margin: 0
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Label/Label.tsx




var Label = function Label(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
    className: (0,es/* css */.iv)(LabelStyle.label, props.styles),
    children: props.children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Label/index.ts


/***/ }),

/***/ 23717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PG": function() { return /* binding */ FlightPriceFilterBlock; },
/* harmony export */   "fM": function() { return /* binding */ initialMinPrice; },
/* harmony export */   "wO": function() { return /* binding */ initialMaxPrice; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_rangeSlider_RangeSliderBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25064);
/* harmony import */ var main_javascripts_components_form_rangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57444);
/* harmony import */ var main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36581);
/* harmony import */ var _form_InputHidden__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81047);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);













var defaultMinPrice = 5000;
var defaultMaxPrice = 30000;
var deltaPrice = 1000;
var initialMinPrice = "min-unlimited";
var initialMaxPrice = "max-unlimited";

var getSliderData = function getSliderData(min, max, delta) {
  var dataArray = [];
  var val = min;
  dataArray.push("min-unlimited");

  while (val < max) {
    dataArray.push(val);
    val += delta;
  }

  dataArray.push(max);
  dataArray.push("max-unlimited");
  return dataArray;
};

var FlightPriceFilterBlock = function FlightPriceFilterBlock(props) {
  var initialPriceLeft = props.initialPriceLeft,
      initialPriceRight = props.initialPriceRight,
      rangeMinPrice = props.rangeMinPrice,
      rangeMaxPrice = props.rangeMaxPrice,
      onClickEnd = props.onClickEnd,
      errors = props.errors;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var minPriceFieldName = "min_price";
  var maxPriceFieldName = "max_price";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      setValue = _useFormContext.setValue;

  var _useWatch = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useWatch */ .qo)({
    control: control,
    name: [minPriceFieldName, maxPriceFieldName]
  }),
      _useWatch2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useWatch, 2),
      minPriceValue = _useWatch2[0],
      maxPriceValue = _useWatch2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(minPriceValue || initialPriceLeft),
      minPrice = _useState[0],
      setMinPrice = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(maxPriceValue || initialPriceRight),
      maxPrice = _useState2[0],
      setMaxPrice = _useState2[1]; // コールバック内で使用するために保持


  var minPriceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(minPrice);
  minPriceRef.current = minPrice;
  var maxPriceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(maxPrice);
  maxPriceRef.current = maxPrice;
  var dataRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setMinPrice(minPriceValue || initialPriceLeft);
  }, [minPriceValue]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setMaxPrice(maxPriceValue || initialPriceRight);
  }, [maxPriceValue]);

  var formattedPrice = function formattedPrice(price) {
    return price && typeof price === "number" ? t("label:common.price", {
      price: price.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,")
    }) : t("label:common.unspecified");
  };

  var onChangePrice = function onChangePrice(direction, posRatio) {
    var price = dataRef.current[Math.floor(posRatio / (1 / dataRef.current.length))];

    if (direction === main_javascripts_components_form_rangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_2__/* .RangeSliderOnChangeLeft */ .q0) {
      setMinPrice(price);
    } else {
      setMaxPrice(price);
    }
  };

  var onClickEndPrice = function onClickEndPrice(direction) {
    if (direction === main_javascripts_components_form_rangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_2__/* .RangeSliderOnChangeLeft */ .q0) {
      setValue(minPriceFieldName, minPriceRef.current);
    } else {
      setValue(maxPriceFieldName, maxPriceRef.current);
    }

    if (onClickEnd) {
      onClickEnd();
    }
  };

  var getMinPriceIndex = function getMinPriceIndex(data, value) {
    var index = data.indexOf(value);

    if (index === -1) {
      index = data.findIndex(function (price) {
        return typeof price !== "string" && Number(value) < price;
      }) - 1;

      if (index < 0) {
        index = 0;
      }
    }

    return index;
  };

  var getMaxPriceIndex = function getMaxPriceIndex(data, value) {
    var index = data.indexOf(value);

    if (index === -1) {
      index = data.findIndex(function (price) {
        return typeof price !== "string" && Number(value) < price;
      });

      if (index < 0) {
        index = data.length - 1;
      }
    }

    return index;
  };

  var renderRangeSlider = function renderRangeSlider() {
    var dataMinPrice = rangeMinPrice || defaultMinPrice;
    var dataMaxPrice = rangeMaxPrice || defaultMaxPrice;
    dataRef.current = getSliderData(dataMinPrice, dataMaxPrice, deltaPrice);
    var data = dataRef.current;
    var initialLeftValue = minPriceValue ? minPriceValue : initialPriceLeft;
    var initialRightValue = maxPriceValue ? maxPriceValue : initialPriceRight;
    initialLeftValue = Number(initialLeftValue) ? Number(initialLeftValue) : initialLeftValue;
    initialRightValue = Number(initialRightValue) ? Number(initialRightValue) : initialRightValue;
    var initialLeft = getMinPriceIndex(data, initialLeftValue) / data.length;
    var initialRight = getMaxPriceIndex(data, initialRightValue) / data.length + 0.999 / data.length;
    var labelText = t("label:common.totalPrice");
    var minPriceError = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .get */ .U2)(errors, minPriceFieldName);
    var maxPriceError = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .get */ .U2)(errors, maxPriceFieldName);
    var error = minPriceError || maxPriceError;
    var name = maxPriceError ? maxPriceFieldName : minPriceFieldName;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(main_javascripts_components_form_rangeSlider_RangeSliderBlock__WEBPACK_IMPORTED_MODULE_1__/* .RangeSliderBlock */ .k, {
      namespace: main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__/* .FormNamespaces.flight */ .Z.flight,
      name: name,
      label: {
        namespace: main_javascripts_constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__/* .FormNamespaces.flight */ .Z.flight,
        label: labelText
      },
      initialLeft: initialLeft,
      initialRight: initialRight,
      dataNum: data.length,
      error: error,
      valLeft: formattedPrice(minPrice || initialLeftValue),
      valRight: formattedPrice(maxPrice || initialRightValue),
      onChange: onChangePrice,
      onClickEnd: onClickEndPrice
    });
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_4__/* .InputHidden */ .R, {
      name: minPriceFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_4__/* .InputHidden */ .R, {
      name: maxPriceFieldName
    }), renderRangeSlider()]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom1_5x */ .D.atom1_5x, " 0;&:after{content:\"\";width:calc(100% - ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom2x */ .D.atom2x, ");display:block;margin:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, " -", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom1_5x */ .D.atom1_5x, ";border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 44464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ InputError; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_utils_StringUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56896);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58589);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);











var InputErrorComponent = function InputErrorComponent(props) {
  var namespace = props.namespace,
      errorMessage = props.errorMessage,
      label = props.label;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var localizedErrorMessage;

  if (typeof errorMessage === "object") {
    // 引数付きのエラーメッセージを変換
    localizedErrorMessage = t("form.errors.messages.".concat(errorMessage.key), errorMessage.options);
  } else {
    localizedErrorMessage = t("form.errors.messages.".concat(errorMessage));
  }

  var labeledErrorMessage;

  if (localizedErrorMessage.indexOf("form.errors.") === 0 || !namespace) {
    // サーバーから受け取ったメッセージはそのまま表示する
    labeledErrorMessage = typeof errorMessage === "string" ? (0,main_javascripts_utils_StringUtil__WEBPACK_IMPORTED_MODULE_2__/* .nl2br */ .hU)(errorMessage) : "";
  } else {
    var individualLabel = label.split(".").slice(-1)[0];
    var localizedLabel = t("".concat(namespace, ".").concat((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelize)(individualLabel)));

    if (localizedLabel.indexOf("".concat(namespace, ".").concat((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelize)(individualLabel))) === 0) {
      localizedLabel = label;
    }

    labeledErrorMessage = t("form.errors.format", {
      label: localizedLabel,
      message: localizedErrorMessage
    });
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
    css: [inputErrorStyle, props.styles,  true ? "" : 0,  true ? "" : 0],
    children: labeledErrorMessage
  });
};

var InputError = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(InputErrorComponent);
var inputErrorStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.smallest */ .JB.smallest, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.caption3 */ .Nv.caption3, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .accentColor.alertColor */ .z.alertColor, ";display:block;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom0_5x */ .D.atom0_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, ";margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom0_5x */ .D.atom0_5x, " 0 0;background:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .shadeColorLog */ .wJ)((0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .hex2rgba */ .rW)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .accentColor.alertColor */ .z.alertColor), 0.8), ";border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius.normal */ .E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 81047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputHidden; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var InputHidden = function InputHidden(props) {
  var name = props.name,
      value = props.value;

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register;

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("input", _objectSpread({
    type: "hidden",
    value: value,
    name: name
  }, register(name)));
};

/***/ }),

/***/ 35183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88433);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Label = function Label(props) {
  var namespace = props.namespace,
      label = props.label,
      annotation = props.annotation,
      isRequired = props.isRequired,
      showLabel = props.showLabel,
      _props$colorStyleKey = props.colorStyleKey,
      colorStyleKey = _props$colorStyleKey === void 0 ? "default" : _props$colorStyleKey;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var localizedLabel = t("".concat(namespace, ".").concat(label));

  if (showLabel || localizedLabel.indexOf("".concat(namespace, ".").concat(label)) === 0) {
    localizedLabel = label;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("label", {
    css: [labelStyle, colorStyle[colorStyleKey],  true ? "" : 0,  true ? "" : 0],
    children: [localizedLabel, annotation, isRequired && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
      css: requiredStyle,
      children: t("common.required")
    })]
  });
};
var labelStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.caption */ .JB.caption, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight.caption3 */ .Nv.caption3, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.bold */ .Ue.bold, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";display:flex;align-items:flex-start;margin:0;padding:0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var requiredStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("display:inline-block;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.alertColor */ .z.alertColor, ";font-size:10px;border-left:1px solid;margin:0.125rem 0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom2x */ .D.atom2x, ";line-height:1;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom0_5x */ .D.atom0_5x, " 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom0_5x */ .D.atom0_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom2x */ .D.atom2x, ";opacity:0.8;white-space:nowrap;" + ( true ? "" : 0),  true ? "" : 0);
var colorStyle = {
  "default": /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)( true ? "" : 0,  true ? "" : 0),
  light:  true ? {
    name: "220rkc",
    styles: "color:#fff"
  } : 0,
  tabletLight: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_4__/* .moreThanBreakpoint */ .h6)("tablet"), "{color:#fff;}" + ( true ? "" : 0),  true ? "" : 0),
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  textSecondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 57444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U2": function() { return /* binding */ RangeSlider; },
  "q0": function() { return /* binding */ RangeSliderOnChangeLeft; }
});

// UNUSED EXPORTS: RangeSliderOnChangeRight

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/shadowStyle.ts
var shadowStyle = __webpack_require__(78698);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/form/rangeSlider/RangeSliderHandle.tsx






var RangeSliderHandle = function RangeSliderHandle(props) {
  var onMove = props.onMove,
      x = props.x,
      onClickEnd = props.onClickEnd,
      position = props.position;
  var selfElmRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    return function () {
      if (selfElmRef.current) {
        selfElmRef.current.removeEventListener("mousedown", onMouseDown);
        selfElmRef.current.removeEventListener("touchstart", onTouchStart);
      }
    };
  }, []);

  var onMouseDown = function onMouseDown(e) {
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    e.preventDefault();
  };

  var onMouseUp = function onMouseUp(e) {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
    e.preventDefault();

    if (onClickEnd) {
      onClickEnd();
    }
  };

  var onMouseMove = function onMouseMove(e) {
    onMove(e.clientX);
    e.preventDefault();
  };

  var onTouchStart = function onTouchStart(e) {
    e.preventDefault();
    document.addEventListener("touchmove", onTouchMove, {
      passive: false
    });
    document.addEventListener("touchend", onTouchEnd, {
      passive: false
    });
  };

  var onTouchMove = function onTouchMove(e) {
    if (e.cancelable) {
      e.preventDefault();
    }

    onMove(e.touches[0].clientX);
  };

  var onTouchEnd = function onTouchEnd() {
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", onTouchEnd);

    if (onClickEnd) {
      onClickEnd();
    }
  };

  var blockStyles = position === "left" ? [handleStyle, handleLeftStyle] : handleStyle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: blockStyles,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    style: {
      left: "".concat(x * 100, "%")
    },
    ref: selfElmRef
  });
};
var handleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:40px;height:40px;position:absolute;top:50%;transform:translateY(-50%);margin-left:-20px;border-radius:50%;background:#fff;box-shadow:", shadowStyle/* boxShadow.interface */.W["interface"], ";border:1px solid ", colorStyle/* borderColor.shadowColor */.tv.shadowColor, ";user-select:none;cursor:pointer;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:30px;height:30px;margin-left:-12px;}" + ( true ? "" : 0),  true ? "" : 0);
var handleLeftStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("&:before{content:\"\";width:10px;height:100%;position:absolute;top:0;left:-10px;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:30px;height:30px;margin-left:-18px;}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/form/rangeSlider/RangeSlider.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var RangeSliderOnChangeLeft = "RangeSliderOnChangeLeft";
var RangeSliderOnChangeRight = "RangeSliderOnChangeRight";
var RangeSlider = function RangeSlider(props) {
  var dataNum = props.dataNum,
      initialLeft = props.initialLeft,
      initialRight = props.initialRight,
      onChange = props.onChange,
      onClickEnd = props.onClickEnd,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;

  var _useState = (0,react.useState)(0),
      xStart = _useState[0],
      setXStart = _useState[1];

  var _useState2 = (0,react.useState)(0),
      xEnd = _useState2[0],
      setXEnd = _useState2[1];

  var _useState3 = (0,react.useState)(initialLeft),
      xLeft = _useState3[0],
      setXLeft = _useState3[1];

  var _useState4 = (0,react.useState)(initialRight),
      xRight = _useState4[0],
      setXRight = _useState4[1];

  var innerElmRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    getSliderPosition();
    window.addEventListener("resize", onResizeWindow);
    return function () {
      innerElmRef.current = null;
      window.removeEventListener("resize", onResizeWindow);
    };
  }, []);
  (0,react.useEffect)(function () {
    setXLeft(initialLeft);
    setXRight(initialRight);
  }, [initialLeft, initialRight]);

  var getSliderPosition = function getSliderPosition() {
    if (innerElmRef.current) {
      setXStart(0);
      setXEnd(innerElmRef.current.clientWidth);
    }
  };

  var onMoveLeft = function onMoveLeft(x) {
    var bounds = innerElmRef.current.getBoundingClientRect();
    var relativeX = x - bounds.left;
    var posRatio = (relativeX - xStart) / (xEnd - xStart);
    var maxPos = xRight - 1 / dataNum;
    posRatio = posRatio > 0 ? posRatio : 0;
    posRatio = posRatio < maxPos ? posRatio : maxPos;
    setXLeft(posRatio);
    onChange(RangeSliderOnChangeLeft, posRatio);
  };

  var onMoveRight = function onMoveRight(x) {
    var bounds = innerElmRef.current.getBoundingClientRect();
    var relativeX = x - bounds.left;
    var posRatio = (relativeX - xStart) / (xEnd - xStart);
    var minPos = xLeft + 1 / dataNum;
    posRatio = posRatio > minPos ? posRatio : minPos;
    posRatio = posRatio < 1 ? posRatio : 0.9999; // 1だと配列数の最大を超えるため制限している

    setXRight(posRatio);
    onChange(RangeSliderOnChangeRight, posRatio);
  };

  var onResizeWindow = function onResizeWindow() {
    getSliderPosition();
  };

  var onClickEndLeft = function onClickEndLeft() {
    if (onClickEnd) {
      onClickEnd(RangeSliderOnChangeLeft);
    }
  };

  var onClickEndRight = function onClickEndRight() {
    if (onClickEnd) {
      onClickEnd(RangeSliderOnChangeRight);
    }
  };

  var block = styles.block,
      bar = styles.bar;
  var barWidthPer = xRight - xLeft;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: [blockStyle, block,  true ? "" : 0,  true ? "" : 0],
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: innerStyle,
      ref: innerElmRef,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: [barStyle, bar,  true ? "" : 0,  true ? "" : 0],
        style: {
          transform: "translateX(".concat(xLeft * 100, "%) scaleX(").concat(barWidthPer, ")")
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeSliderHandle, {
        x: xLeft,
        position: "left",
        onMove: onMoveLeft,
        onClickEnd: onClickEndLeft
      }, "left"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeSliderHandle, {
        x: xRight,
        position: "right",
        onMove: onMoveRight,
        onClickEnd: onClickEndRight
      }, "right")]
    })
  });
};
var blockStyle =  true ? {
  name: "1wii3q8",
  styles: "position:relative;height:40px"
} : 0;
var innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;height:100%;width:calc(100% - (", spaceStyle/* space.atom2x */.D.atom2x, " * 2));margin:0 auto;&:before{content:\"\";width:calc(100% + (", spaceStyle/* space.atom2x */.D.atom2x, " * 2));height:4px;position:absolute;top:50%;left:-", spaceStyle/* space.atom2x */.D.atom2x, ";margin-top:-2px;background:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var barStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:50%;height:4px;background:", colorStyle/* accentColor.primaryColor2 */.z.primaryColor2, ";width:100%;margin-top:-2px;transform-origin:left;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 25064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ RangeSliderBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_components_form_rangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57444);
/* harmony import */ var main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44464);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36716);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var RangeSliderBlock = function RangeSliderBlock(props) {
  var name = props.name,
      namespace = props.namespace,
      label = props.label,
      dataNum = props.dataNum,
      initialLeft = props.initialLeft,
      initialRight = props.initialRight,
      valLeft = props.valLeft,
      valRight = props.valRight,
      onChange = props.onChange,
      onClickEnd = props.onClickEnd,
      error = props.error;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_2__/* .Label */ ._, _objectSpread({}, label)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
      css: valueStyle,
      children: [valLeft, " - ", valRight]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_rangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_3__/* .RangeSlider */ .U2, {
      initialLeft: initialLeft,
      initialRight: initialRight,
      dataNum: dataNum,
      onChange: onChange,
      onClickEnd: onClickEnd
    }), error && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .p, {
      namespace: namespace,
      errorMessage: error.message,
      label: name
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("width:100%;padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, " - (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .lineHeight.body1 */ .Nv.body1, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom2x */ .D.atom2x, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var valueStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("padding-bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom0_5x */ .D.atom0_5x, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .fontSize.body */ .JB.body, ";min-height:28px;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 3559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wO": function() { return /* binding */ initialMaxPrice; },
  "fM": function() { return /* binding */ initialMinPrice; }
});

// UNUSED EXPORTS: HotelPriceFilterBlock

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Form/HotelPriceFilterBlock/HotelPriceFilterBlockStyle.ts





var HotelPriceFilterBlockStyle = es/* StyleSheet.create */.mM.create({
  block: {
    padding: "".concat(spaceStyle/* space.atom1_5x */.D.atom1_5x, " 0"),
    ":after": {
      content: '""',
      width: "calc(100% - ".concat(spaceStyle/* space.atom2x */.D.atom2x, ")"),
      display: "block",
      margin: "0 ".concat(spaceStyle/* space.atom */.D.atom, " -").concat(spaceStyle/* space.atom1_5x */.D.atom1_5x),
      borderBottom: "1px solid ".concat(colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor)
    }
  },
  handleLeft: (0,defineProperty/* default */.Z)({}, (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), {
    width: "30px",
    height: "30px",
    marginLeft: "-18px"
  }),
  handleRight: (0,defineProperty/* default */.Z)({}, (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), {
    width: "30px",
    height: "30px",
    marginLeft: "-12px"
  })
});
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Form/RangeSliderBlock/index.ts + 3 modules
var RangeSliderBlock = __webpack_require__(7112);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/RangeSlider.tsx + 1 modules
var RangeSlider = __webpack_require__(14907);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Form/HotelPriceFilterBlock/HotelPriceFilterBlock.tsx








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var minPrice = 1000;
var maxPrice = 30000;
var deltaPrice = 1000;
var initialMinPrice = "min-unlimited";
var initialMaxPrice = "max-unlimited";

var getSliderData = function getSliderData(min, max, delta) {
  var dataArray = [];
  var val = min;
  dataArray.push("min-unlimited");

  while (val < max) {
    dataArray.push(val);
    val += delta;
  }

  dataArray.push(max);
  dataArray.push("max-unlimited");
  return dataArray;
};

var data = getSliderData(minPrice, maxPrice, deltaPrice);
var HotelPriceFilterBlock = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(HotelPriceFilterBlock, _React$Component);

  var _super = _createSuper(HotelPriceFilterBlock);

  function HotelPriceFilterBlock(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HotelPriceFilterBlock);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onChangePrice", function (direction, posRatio) {
      var price = data[Math.floor(posRatio / (1 / data.length))];

      if (direction === RangeSlider/* RangeSliderOnChangeLeft */.q0) {
        _this.setState({
          minPrice: price
        });
      } else {
        _this.setState({
          maxPrice: price
        });
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onClickEnd", function (direction) {
      if (direction === RangeSlider/* RangeSliderOnChangeLeft */.q0) {
        _this.props.change("min_price", _this.state.minPrice);
      } else {
        _this.props.change("max_price", _this.state.maxPrice);
      }

      if (_this.props.onClickEnd) {
        _this.props.onClickEnd();
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderRangeSlider", function (_ref) {
      var input = _ref.input,
          meta = _ref.meta;
      var _this$props = _this.props,
          values = _this$props.values,
          initialPriceLeft = _this$props.initialPriceLeft,
          initialPriceRight = _this$props.initialPriceRight;
      var initialLeftValue = values.min_price ? values.min_price : initialPriceLeft;
      var initialRightValue = values.max_price ? values.max_price : initialPriceRight;
      initialLeftValue = Number(initialLeftValue) ? Number(initialLeftValue) : initialLeftValue;
      initialRightValue = Number(initialRightValue) ? Number(initialRightValue) : initialRightValue;
      var initialLeft = data.indexOf(initialLeftValue) / data.length;
      var initialRight = data.indexOf(initialRightValue) / data.length + 0.999 / data.length;
      var labelText = "1名1泊あたりの価格";
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeSliderBlock/* RangeSliderBlock */.k, {
        label: {
          children: labelText
        },
        input: _objectSpread({}, input),
        initialLeft: initialLeft,
        initialRight: initialRight,
        dataNum: data.length,
        inputError: {
          meta: meta
        },
        valLeft: _this.formattedPrice(_this.state.minPrice || initialLeftValue),
        valRight: _this.formattedPrice(_this.state.maxPrice || initialRightValue),
        onChange: _this.onChangePrice,
        onClickEnd: _this.onClickEnd,
        styles: {
          handleLeft: HotelPriceFilterBlockStyle.handleLeft,
          handleRight: HotelPriceFilterBlockStyle.handleRight
        }
      });
    });

    _this.state = {
      minPrice: props.values && props.values.min_price ? props.values.min_price : props.initialPriceLeft,
      maxPrice: props.values && props.values.max_price ? props.values.max_price : props.initialPriceRight
    };
    return _this;
  }

  (0,createClass/* default */.Z)(HotelPriceFilterBlock, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.values && (!prevProps.values || prevProps.values.min_price !== this.props.values.min_price || prevProps.values.max_price !== this.props.values.max_price)) {
        this.setState({
          minPrice: this.props.values.min_price || this.props.initialPriceLeft,
          maxPrice: this.props.values.max_price || this.props.initialPriceRight
        });
      }
    }
  }, {
    key: "formattedPrice",
    value: function formattedPrice(price) {
      return price && typeof price === "number" ? "".concat(price.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,"), "\u5186") : "未設定";
    }
  }, {
    key: "render",
    value: function render() {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (0,es/* css */.iv)(HotelPriceFilterBlockStyle.block),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
          name: "min_price",
          component: "input",
          type: "hidden"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
          name: "max_price",
          component: "input",
          type: "hidden"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
          name: "prices",
          subscription: {
            error: true
          } // エラー専用
          ,
          component: this.renderRangeSlider
        })]
      });
    }
  }]);

  return HotelPriceFilterBlock;
}(react.Component);

/***/ }),

/***/ 7112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ RangeSliderBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Label/index.ts + 2 modules
var Label = __webpack_require__(81432);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/RangeSliderStyle.ts
var RangeSliderStyle = __webpack_require__(84543);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/RangeSlider.tsx + 1 modules
var RangeSlider = __webpack_require__(14907);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Form/RangeSlider/index.ts


// EXTERNAL MODULE: ./main/javascripts/components/atoms/Form/InputError/index.ts + 2 modules
var InputError = __webpack_require__(5706);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Form/RangeSliderBlock/RangeSliderBlockStyle.ts



var RangeSliderBlockStyle = es/* StyleSheet.create */.mM.create({
  block: {
    width: "100%",
    padding: "calc(".concat(spaceStyle/* space.atom */.D.atom, " - (").concat(typographyStyle/* lineHeight.body1 */.Nv.body1, " - ").concat(typographyStyle/* fontSize.body */.JB.body, ")/2) ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom2x */.D.atom2x),
    boxSizing: "border-box"
  },
  value: {
    paddingBottom: spaceStyle/* space.atom0_5x */.D.atom0_5x,
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    minHeight: "28px"
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Form/RangeSliderBlock/RangeSliderBlock.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var RangeSliderBlock = function RangeSliderBlock(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;
  var block = styles.block,
      label = styles.label,
      handleLeft = styles.handleLeft,
      handleRight = styles.handleRight;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (0,es/* css */.iv)(RangeSliderBlockStyle.block, block),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* Label */._, _objectSpread(_objectSpread({}, props.label), {}, {
      styles: label,
      children: props.label.children
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (0,es/* css */.iv)(RangeSliderBlockStyle.value),
      children: [props.valLeft, " - ", props.valRight]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeSlider/* RangeSlider */.U2, _objectSpread(_objectSpread({
      initialLeft: props.initialLeft,
      initialRight: props.initialRight,
      dataNum: props.dataNum
    }, props.input), {}, {
      onChange: props.onChange,
      styles: {
        handleLeft: handleLeft,
        handleRight: handleRight
      },
      onClickEnd: props.onClickEnd
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, _objectSpread({
      isIndependent: true
    }, props.inputError))]
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Form/RangeSliderBlock/index.ts


/***/ }),

/***/ 74618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FlightDestinationTypes; }
/* harmony export */ });
var FlightDestinationTypes = {
  origin: "origin",
  destination: "destination"
};

/***/ }),

/***/ 45021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ FlightTypes; }
/* harmony export */ });
var FlightTypes = {
  oneWay: "one_way",
  roundTrip: "round_trip",
  multiCity: "multi_city"
};

/***/ }),

/***/ 36581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormNamespaces; },
/* harmony export */   "b": function() { return /* binding */ yupDefaultMessages; }
/* harmony export */ });
var yupDefaultMessages = {
  mixed: {
    required: "blank"
  },
  number: {
    positive: "notAPositive",
    integer: "notAnInteger",
    min: function min(_ref) {
      var _min = _ref.min;
      return {
        key: "greaterThanOrEqualTo",
        options: {
          count: _min
        }
      };
    },
    max: function max(_ref2) {
      var _max = _ref2.max;
      return {
        key: "lessThanOrEqualTo",
        options: {
          count: _max
        }
      };
    }
  },
  string: {
    email: "formatInvalid"
  },
  array: {
    min: "arrayTooFew"
  }
}; // TODO

var FormNamespaces = {
  hotel: "hotel",
  flight: "flight",
  emailUser: "emailUser"
};

/***/ }),

/***/ 94737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ deleteCmsPostUpdate; },
/* harmony export */   "E2": function() { return /* binding */ loadingSelector; },
/* harmony export */   "J_": function() { return /* binding */ deleteCmsPost; },
/* harmony export */   "KD": function() { return /* binding */ numPerPageSelector; },
/* harmony export */   "ON": function() { return /* binding */ cmsSlice; },
/* harmony export */   "Os": function() { return /* binding */ putCmsPostUpdate; },
/* harmony export */   "Pq": function() { return /* binding */ initPosts; },
/* harmony export */   "_p": function() { return /* binding */ pageSelector; },
/* harmony export */   "nS": function() { return /* binding */ postUpdateSelector; },
/* harmony export */   "nj": function() { return /* binding */ fetchCmsPosts; },
/* harmony export */   "rN": function() { return /* binding */ totalNumSelector; },
/* harmony export */   "t5": function() { return /* binding */ fetchCmsPostUpdate; },
/* harmony export */   "xE": function() { return /* binding */ postsSelector; }
/* harmony export */ });
/* unused harmony exports fetchCmsIndexPage, fetchPostSuggestions, postCmsRelatedPosts, postByIdSelector, postIdsSelector, postEntitiesSelector, totalPostsSelector, postIdSelector, postSelector, errorsSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);








var key = "cms";
var adapter = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createEntityAdapter */ .HF)(); // Postとほぼ内容が同じなためPostEntityStateを使用している
// Cms独自のデータ管理が必要になった場合はCmsEntityStateを作成するか、
// 独自のStateを定義してその中にPostEntityStateを含める

var initialState = adapter.getInitialState({
  errors: null,
  postId: undefined,
  page: 0,
  numPerPage: 0,
  totalNum: 0,
  isLastPage: false,
  tag: null,
  region: null,
  rankings: [],
  popularTags: [],
  loading: false,
  postUpdate: null
});
/** Async **/

var fetchCmsIndexPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchCmsIndexPage"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, param, _args$isServerSide, isServerSide, headers, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            param = args.param, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? true : _args$isServerSide, headers = args.headers;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms.json?").concat(param);
            _context.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 6:
            result = _context.sent;
            return _context.abrupt("return", {
              posts: result.data.posts,
              totalNum: result.data.totalNum,
              page: result.data.page,
              numPerPage: result.data.numPerPage
            });

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context.t0.response.data)));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var fetchCmsPosts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchCmsPosts"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, param, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            param = args.param;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms/posts.json?").concat(param);
            _context2.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().get(url);

          case 6:
            result = _context2.sent;
            return _context2.abrupt("return", {
              posts: result.data.posts,
              totalNum: result.data.totalNum,
              page: result.data.page,
              numPerPage: result.data.numPerPage
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context2.t0.response.data)));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}()); // 現在未使用
// 記事編集ページをredux toolkit化した際に使用する

var fetchPostSuggestions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchPostSuggestions"), /*#__PURE__*/function () {
  var _ref6 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(args, _ref5) {
    var rejectWithValue, title, limit, paramString, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue;
            _context3.prev = 1;
            title = args.title, limit = args.limit;
            paramString = (0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)({
              title: title,
              limit: limit
            }, {
              arrayFormat: "brackets"
            });
            url = "/api/posts/suggests.json?".concat(paramString);
            _context3.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().get(url);

          case 7:
            result = _context3.sent;
            return _context3.abrupt("return", {
              posts: result.data
            });

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context3.t0.response.data)));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 11]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}()); // 現在未使用
// 記事編集ページをredux toolkit化した際に使用する

var postCmsRelatedPosts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/postCmsRelatedPosts"), /*#__PURE__*/function () {
  var _ref8 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(args, _ref7) {
    var rejectWithValue, postId, params, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            rejectWithValue = _ref7.rejectWithValue;
            _context4.prev = 1;
            postId = args.postId, params = args.params;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms/posts/").concat(postId, "/related_posts.json");
            _context4.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().post(url, params);

          case 6:
            result = _context4.sent;
            return _context4.abrupt("return", {
              post: result.data.post
            });

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context4.t0.response.data)));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 10]]);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}());
var deleteCmsPost = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/deleteCmsPost"), /*#__PURE__*/function () {
  var _ref10 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(args, _ref9) {
    var rejectWithValue, postId, url;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            rejectWithValue = _ref9.rejectWithValue;
            _context5.prev = 1;
            postId = args.postId;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms/posts/").concat(postId, ".json");
            _context5.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)()["delete"](url);

          case 6:
            return _context5.abrupt("return", {
              id: postId
            });

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context5.t0.response.data)));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 9]]);
  }));

  return function (_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}());
var fetchCmsPostUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchCmsPostUpdate"), /*#__PURE__*/function () {
  var _ref12 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(args, _ref11) {
    var rejectWithValue, postId, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            rejectWithValue = _ref11.rejectWithValue;
            _context6.prev = 1;
            postId = args.postId;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms/posts/").concat(postId, "/post_update.json");
            _context6.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().get(url);

          case 6:
            result = _context6.sent;
            return _context6.abrupt("return", {
              postUpdate: result.data.postUpdate
            });

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](1);
            return _context6.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context6.t0.response.data)));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 10]]);
  }));

  return function (_x11, _x12) {
    return _ref12.apply(this, arguments);
  };
}());
var putCmsPostUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/putCmsPostUpdate"), /*#__PURE__*/function () {
  var _ref14 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(args, _ref13) {
    var rejectWithValue, postId, params, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            rejectWithValue = _ref13.rejectWithValue;
            _context7.prev = 1;
            postId = args.postId, params = args.params;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms/posts/").concat(postId, "/post_update.json");
            _context7.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().put(url, {
              post_update: params
            });

          case 6:
            result = _context7.sent;
            return _context7.abrupt("return", {
              postUpdate: result.data.postUpdate
            });

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context7.t0.response.data)));

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 10]]);
  }));

  return function (_x13, _x14) {
    return _ref14.apply(this, arguments);
  };
}());
var deleteCmsPostUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/deleteCmsPostUpdate"), /*#__PURE__*/function () {
  var _ref16 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(args, _ref15) {
    var rejectWithValue, postId, url;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            rejectWithValue = _ref15.rejectWithValue;
            _context8.prev = 1;
            postId = args.postId;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/cms/posts/").concat(postId, "/post_update.json");
            _context8.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)()["delete"](url);

          case 6:
            return _context8.abrupt("return", {
              id: postId
            });

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](1);
            return _context8.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context8.t0.response.data)));

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 9]]);
  }));

  return function (_x15, _x16) {
    return _ref16.apply(this, arguments);
  };
}());
/** slice **/

var cmsSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initPosts: function initPosts(state, action) {
      adapter.setAll(state, action.payload.posts);
      state.totalNum = action.payload.totalNum;
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchCmsIndexPage.fulfilled, function (state, action) {
      adapter.setAll(state, action.payload.posts);
      state.totalNum = action.payload.totalNum;
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
    }).addCase(fetchCmsPosts.fulfilled, function (state, action) {
      adapter.setAll(state, action.payload.posts);
      state.totalNum = action.payload.totalNum;
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
    }).addCase(fetchCmsPostUpdate.fulfilled, function (state, action) {
      state.postUpdate = action.payload.postUpdate;
    }).addCase(putCmsPostUpdate.fulfilled, function (state, action) {
      state.postUpdate = action.payload.postUpdate;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var _adapter$getSelectors = adapter.getSelectors(function (state) {
  return state.cms;
}),
    postByIdSelector = _adapter$getSelectors.selectById,
    postIdsSelector = _adapter$getSelectors.selectIds,
    postEntitiesSelector = _adapter$getSelectors.selectEntities,
    postsSelector = _adapter$getSelectors.selectAll,
    totalPostsSelector = _adapter$getSelectors.selectTotal;



var stateSelector = function stateSelector(state) {
  return state[key];
};

var postIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.postId;
});
var postSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)([postEntitiesSelector, postIdSelector], function (entities, postId) {
  return entities[postId];
});
var postUpdateSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.postUpdate;
});
var totalNumSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.totalNum;
});
var pageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.page;
});
var numPerPageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.numPerPage;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var initPosts = cmsSlice.actions.initPosts;


/***/ }),

/***/ 79283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ authEmailChatUnit; },
/* harmony export */   "lJ": function() { return /* binding */ emailUserSlice; }
/* harmony export */ });
/* unused harmony exports errorsSelector, loadingSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25968);







var key = "emailUser";
var initialState = {
  errors: null,
  loading: false
};
/** Async **/

var authEmailChatUnit = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("".concat(key, "/authEmailChatUnit"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, email, password, chatUnitToken, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            email = args.email, password = args.password, chatUnitToken = args.chatUnitToken; // console.log(headers);

            _context.next = 5;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)().post("".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__/* .PATH_SCOPE */ .j1, "/api/email_chat_unit_authentications.json"), {
              email: email,
              password: password,
              chat_unit_token: chatUnitToken
            });

          case 5:
            result = _context.sent;
            return _context.abrupt("return", {
              user: result.data.user
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context.t0.response.data)));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/** slice **/

var emailUserSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});

/***/ }),

/***/ 55030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isPushedFlightDetailModalUrlSelector; },
/* harmony export */   "C1": function() { return /* binding */ parseTechnicalStops; },
/* harmony export */   "E2": function() { return /* binding */ loadingSelector; },
/* harmony export */   "Ew": function() { return /* binding */ getNumberOfConnections; },
/* harmony export */   "I4": function() { return /* binding */ fetchFlights; },
/* harmony export */   "IH": function() { return /* binding */ minTotalPriceCentsSelector; },
/* harmony export */   "Id": function() { return /* binding */ isPollingSelector; },
/* harmony export */   "KD": function() { return /* binding */ numPerPageSelector; },
/* harmony export */   "LC": function() { return /* binding */ isDurationOver1Hour; },
/* harmony export */   "LE": function() { return /* binding */ isPollingCompletedSelector; },
/* harmony export */   "Q6": function() { return /* binding */ transitAirportsSelector; },
/* harmony export */   "S4": function() { return /* binding */ setPollingCondition; },
/* harmony export */   "T4": function() { return /* binding */ lastFlightDetail; },
/* harmony export */   "Tf": function() { return /* binding */ isCodeshare; },
/* harmony export */   "Tt": function() { return /* binding */ totalDurationHours; },
/* harmony export */   "VV": function() { return /* binding */ departureAirportsSelector; },
/* harmony export */   "WS": function() { return /* binding */ isDisplayedSearchFormSelector; },
/* harmony export */   "XT": function() { return /* binding */ initFlightById; },
/* harmony export */   "XU": function() { return /* binding */ initFlight; },
/* harmony export */   "Yk": function() { return /* binding */ totalDurationMinutes; },
/* harmony export */   "ZF": function() { return /* binding */ airlinesSelector; },
/* harmony export */   "ZX": function() { return /* binding */ fetchFlightInfo; },
/* harmony export */   "Zt": function() { return /* binding */ initFlights; },
/* harmony export */   "_p": function() { return /* binding */ pageSelector; },
/* harmony export */   "eh": function() { return /* binding */ setDisplayFlightSearchForm; },
/* harmony export */   "fr": function() { return /* binding */ camelizedCabinClass; },
/* harmony export */   "g7": function() { return /* binding */ firstFlightDetail; },
/* harmony export */   "h8": function() { return /* binding */ flightSelector; },
/* harmony export */   "lL": function() { return /* binding */ itineraryIndexText; },
/* harmony export */   "nq": function() { return /* binding */ isDisplayedFlightDetailModalSelector; },
/* harmony export */   "nr": function() { return /* binding */ hasAdditionalBaggage; },
/* harmony export */   "o4": function() { return /* binding */ flightSlice; },
/* harmony export */   "qA": function() { return /* binding */ maxStopSelector; },
/* harmony export */   "rN": function() { return /* binding */ totalNumSelector; },
/* harmony export */   "r_": function() { return /* binding */ durationHours; },
/* harmony export */   "rv": function() { return /* binding */ maxTotalPriceCentsSelector; },
/* harmony export */   "vD": function() { return /* binding */ flightsSelector; },
/* harmony export */   "vv": function() { return /* binding */ setDisplayFlightDetailModal; },
/* harmony export */   "wQ": function() { return /* binding */ isTotalDurationOver1Hour; },
/* harmony export */   "y4": function() { return /* binding */ setIsPushedFlightDetailModalUrl; },
/* harmony export */   "z9": function() { return /* binding */ durationMinutes; }
/* harmony export */ });
/* unused harmony exports fetchFlightsIndexPage, fetchFlightsShowPage, fetchCarouselFlightsShowPage, flightByIdSelector, flightIdsSelector, flightEntitiesSelector, totalFlightsSelector, flightIdSelector, airportsSelector, errorsSelector, getFlightDetails, isFreeBaggageEmpty, parseFreeBaggage, isFreeBaggageContentEmpty, isBaggageOptionEmpty */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12902);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22222);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43012);
/* harmony import */ var main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16341);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











// import {
//   flightShowParamFlightPlanIdSelector,
//   flightShowParamFlightRoomIdSelector,
// } from "main/javascripts/slices/paramSlice";
// 旧carouselFlightReducerもflightSliceと統合
var key = "flight";
var adapter = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createEntityAdapter */ .HF)();
var MAX_UPDATED_FLIGHT_COUNT =  true ? 180 : 0;
var initialState = adapter.getInitialState({
  flight: null,
  flightId: "",
  page: 0,
  numPerPage: 0,
  totalNum: 0,
  updatedFlightCount: 0,
  isPolling: false,
  isPollingCompleted: false,
  pollingCondition: null,
  airlines: [],
  airports: [],
  departureAirports: [],
  transitAirports: [],
  maxStop: 0,
  maxTotalPriceCents: 0,
  minTotalPriceCents: 0,
  isDisplayedSearchForm: false,
  isDisplayedFlightDetailModal: false,
  isPushedFlightDetailModalUrl: false,
  loading: false,
  errors: null
});
/** Async **/

var fetchFlightsIndexPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchFlightsIndexPage"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, _args$isServerSide, isServerSide, headers, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? false : _args$isServerSide, headers = args.headers;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_3__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/page/flights.json?".concat(param);
            _context.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_5__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 7:
            result = _context.sent;
            return _context.abrupt("return", {
              param: result.data.param,
              flights: result.data.flights,
              numPerPage: result.data.numPerPage,
              page: result.data.page,
              totalNum: result.data.totalNum,
              facebookAppId: result.data.facebookAppId || ""
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_3__.camelizeKeys)(_context.t0.response.data)));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var fetchFlightsShowPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchFlightsShowPage"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, id, params, _args$isServerSide2, isServerSide, headers, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            id = args.id, params = args.params, _args$isServerSide2 = args.isServerSide, isServerSide = _args$isServerSide2 === void 0 ? false : _args$isServerSide2, headers = args.headers;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_3__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/page/flights/".concat(id, ".json?").concat(param);
            _context2.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_5__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 7:
            result = _context2.sent;
            return _context2.abrupt("return", {
              carouselFlight: result.data.carouselFlight,
              param: result.data.param,
              facebookAppId: result.data.facebookAppId || ""
            });

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_3__.camelizeKeys)(_context2.t0.response.data)));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var fetchCarouselFlightsShowPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchCarouselFlightsShowPage"), /*#__PURE__*/function () {
  var _ref6 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(args, _ref5) {
    var rejectWithValue, id, params, _args$isServerSide3, isServerSide, headers, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue;
            _context3.prev = 1;
            id = args.id, params = args.params, _args$isServerSide3 = args.isServerSide, isServerSide = _args$isServerSide3 === void 0 ? false : _args$isServerSide3, headers = args.headers;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_3__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/carousel_flights/".concat(id, ".json?").concat(param);
            _context3.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_5__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 7:
            result = _context3.sent;
            return _context3.abrupt("return", {
              carouselFlight: result.data.carouselFlight
            });

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_3__.camelizeKeys)(_context3.t0.response.data)));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 11]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}()); // ポーリングする場合は必ず事前にsetPollingConditionを実施すること

var fetchFlights = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchFlights"), /*#__PURE__*/function () {
  var _ref8 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(args, _ref7) {
    var rejectWithValue, params, _args$isPollingReques, isPollingRequest, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            rejectWithValue = _ref7.rejectWithValue;
            _context4.prev = 1;
            params = args.params, _args$isPollingReques = args.isPollingRequest, isPollingRequest = _args$isPollingReques === void 0 ? false : _args$isPollingReques;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_3__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/flights.json?".concat(param);
            _context4.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_5__/* .createWrapper */ .K)().get(url);

          case 7:
            result = _context4.sent;
            return _context4.abrupt("return", {
              flights: result.data.flights,
              isPolling: result.data.isPolling,
              page: result.data.page,
              numPerPage: result.data.numPerPage,
              totalNum: result.data.totalNum,
              airlines: result.data.airlines,
              airports: result.data.airports,
              departureAirports: result.data.departureAirports,
              transitAirports: result.data.transitAirports,
              maxStop: result.data.maxStop,
              maxTotalPriceCents: result.data.maxTotalPriceCents,
              minTotalPriceCents: result.data.minTotalPriceCents,
              isPollingRequest: isPollingRequest,
              params: params
            });

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_3__.camelizeKeys)(_context4.t0.response.data)));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 11]]);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}());
var fetchFlightInfo = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchFlightInfo"), /*#__PURE__*/function () {
  var _ref10 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(args, _ref9) {
    var rejectWithValue, flightId, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            rejectWithValue = _ref9.rejectWithValue;
            _context5.prev = 1;
            flightId = args.flightId;
            url = "/api/flights/".concat(flightId, "/flight_info.json");
            _context5.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_5__/* .createWrapper */ .K)().get(url);

          case 6:
            result = _context5.sent;
            return _context5.abrupt("return", {
              flight: result.data
            });

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_3__.camelizeKeys)(_context5.t0.response.data)));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 10]]);
  }));

  return function (_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}());
/** slice **/

var flightSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initFlight: function initFlight(state, action) {
      state.flightId = action.payload.id;
      state.flight = action.payload;
    },
    initFlightById: function initFlightById(state, action) {
      var flight = state.entities[action.payload];
      state.flightId = flight.id;
      state.flight = flight;
    },
    initFlights: function initFlights(state, action) {
      adapter.setAll(state, action.payload.flights || []);
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
      state.totalNum = action.payload.totalNum;
    },
    setDisplayFlightSearchForm: function setDisplayFlightSearchForm(state, action) {
      state.isDisplayedSearchForm = action.payload;
    },
    setDisplayFlightDetailModal: function setDisplayFlightDetailModal(state, action) {
      state.isDisplayedFlightDetailModal = action.payload;
    },
    setIsPushedFlightDetailModalUrl: function setIsPushedFlightDetailModalUrl(state, action) {
      state.isPushedFlightDetailModalUrl = action.payload;
    },
    setPollingCondition: function setPollingCondition(state, action) {
      state.pollingCondition = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchFlights.pending, function (state) {
      state.isPolling = true;
      state.isPollingCompleted = false;
      state.updatedFlightCount = 0;
    }).addCase(fetchFlights.fulfilled, function (state, action) {
      // ポーリングの場合paramsが異なるアクションは無視する
      var isPollingRequest = action.payload.isPollingRequest;
      var currentCondition = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .removeEmpty */ .HO)((0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .current */ .Vk)(state.pollingCondition));
      var params = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .removeEmpty */ .HO)(action.payload.params);

      if (isPollingRequest && !react_fast_compare__WEBPACK_IMPORTED_MODULE_4___default()(currentCondition, params)) {
        return;
      }

      adapter.setAll(state, action.payload.flights || []);
      var updatedFlightCount = state.updatedFlightCount > MAX_UPDATED_FLIGHT_COUNT ? 0 : state.updatedFlightCount + 1;
      var isPolling = updatedFlightCount === 0 ? false : action.payload.isPolling;
      state.isPolling = isPolling;
      state.isPollingCompleted = !isPolling;
      state.page = action.payload.page; // state.numPerPage = action.payload.numPerPage;

      state.totalNum = action.payload.totalNum;
      state.airlines = action.payload.airlines;
      state.airports = action.payload.airports;
      state.departureAirports = action.payload.departureAirports;
      state.transitAirports = action.payload.transitAirports;
      state.maxStop = action.payload.maxStop;
      state.maxTotalPriceCents = action.payload.maxTotalPriceCents;
      state.minTotalPriceCents = action.payload.minTotalPriceCents;
      state.updatedFlightCount = updatedFlightCount;
    }).addCase(fetchFlights.rejected, function (state, _action) {
      state.isPolling = false;
      state.isPollingCompleted = true;
      state.page = 1;
    }).addCase(fetchFlightInfo.fulfilled, function (state, action) {
      var newFlight = action.payload.flight;

      if (newFlight && !(0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .isObjectEmpty */ .nK)(newFlight)) {
        state.flight = newFlight;
      }
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_6__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_6__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_6__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var _adapter$getSelectors = adapter.getSelectors(function (state) {
  return state.flight;
}),
    flightByIdSelector = _adapter$getSelectors.selectById,
    flightIdsSelector = _adapter$getSelectors.selectIds,
    flightEntitiesSelector = _adapter$getSelectors.selectEntities,
    flightsSelector = _adapter$getSelectors.selectAll,
    totalFlightsSelector = _adapter$getSelectors.selectTotal;



var stateSelector = function stateSelector(state) {
  return state[key];
};

var flightSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flight;
});
var flightIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightId;
});
var pageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.page;
});
var numPerPageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.numPerPage;
});
var totalNumSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.totalNum;
});
var isPollingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isPolling;
});
var isPollingCompletedSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isPollingCompleted;
});
var airlinesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.airlines;
});
var airportsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.airports;
});
var departureAirportsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.departureAirports;
});
var transitAirportsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.transitAirports;
});
var maxStopSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.maxStop;
});
var maxTotalPriceCentsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.maxTotalPriceCents;
});
var minTotalPriceCentsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.minTotalPriceCents;
});
var isDisplayedSearchFormSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isDisplayedSearchForm;
});
var isDisplayedFlightDetailModalSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isDisplayedFlightDetailModal;
});
var isPushedFlightDetailModalUrlSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isPushedFlightDetailModalUrl;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var _flightSlice$actions = flightSlice.actions,
    initFlight = _flightSlice$actions.initFlight,
    initFlightById = _flightSlice$actions.initFlightById,
    initFlights = _flightSlice$actions.initFlights,
    setDisplayFlightSearchForm = _flightSlice$actions.setDisplayFlightSearchForm,
    setDisplayFlightDetailModal = _flightSlice$actions.setDisplayFlightDetailModal,
    setIsPushedFlightDetailModalUrl = _flightSlice$actions.setIsPushedFlightDetailModalUrl,
    setPollingCondition = _flightSlice$actions.setPollingCondition; // Flight


var hasAdditionalBaggage = function hasAdditionalBaggage(flight) {
  return !!flight.additionalBaggageItems.find(function (baggageOption) {
    return !isBaggageOptionEmpty(baggageOption);
  });
}; // Flight.Itinerary

var isTotalDurationOver1Hour = function isTotalDurationOver1Hour(itinerary) {
  return itinerary.duration >= 60;
};
var totalDurationMinutes = function totalDurationMinutes(itinerary) {
  return itinerary.duration % 60;
};
var totalDurationHours = function totalDurationHours(itinerary) {
  return Math.floor(itinerary.duration / 60);
};
var firstFlightDetail = function firstFlightDetail(itinerary) {
  return itinerary.flightDetails[0];
};
var lastFlightDetail = function lastFlightDetail(itinerary) {
  return itinerary.flightDetails[itinerary.flightDetails.length - 1];
};
var getNumberOfConnections = function getNumberOfConnections(itinerary) {
  return getFlightDetails(itinerary).length - 1;
};
var getFlightDetails = function getFlightDetails(itinerary) {
  return itinerary.flightDetails.reduce(function (array, detail) {
    var newDetails = parseTechnicalStops(detail);
    return array.concat(newDetails);
  }, []);
}; // Flight.Detail

var camelizedCabinClass = function camelizedCabinClass(flightDetail) {
  return (0,humps__WEBPACK_IMPORTED_MODULE_3__.camelize)(flightDetail.cabinClass);
};
var isCodeshare = function isCodeshare(flightDetail) {
  return flightDetail.marketingAirlineCode !== flightDetail.operatingAirlineCode;
};
var isDurationOver1Hour = function isDurationOver1Hour(flightDetail) {
  return flightDetail.duration >= 60;
};
var durationMinutes = function durationMinutes(flightDetail) {
  return flightDetail.duration % 60;
};
var durationHours = function durationHours(flightDetail) {
  return Math.floor(flightDetail.duration / 60);
};
function parseTechnicalStops(detail) {
  var parsedDetails = [];
  var technicalStops = detail.technicalStops;

  if (!technicalStops || technicalStops.length === 0) {
    parsedDetails.push(detail);
    return parsedDetails;
  }

  var stopCount = technicalStops.length;
  technicalStops.map(function (technicalStop, index) {
    if (index === 0) {
      // first
      parsedDetails.push(_objectSpread(_objectSpread({}, detail), {}, {
        arrivalAirportName: technicalStop.airportName,
        arrivalAirportShortName: technicalStop.airportShortName,
        arrivalAirportCode: technicalStop.airportCode,
        arrivalDate: technicalStop.arrivalDate,
        arrivalTime: technicalStop.arrivalTime,
        technicalStops: [],
        // duration: differenceInMinutes(
        //   `${technicalStop.arrivalDate} ${technicalStop.arrivalTime}`,
        //   `${detail.departureDate} ${detail.departureTime}`,
        // ),
        duration: 0
      }));
    }

    if (index > 0 && stopCount > 1) {
      // others
      var prevStop = technicalStops[index - 1];
      var layover = (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_13__/* .parseDate */ .s)("".concat(prevStop.departureDate, " ").concat(prevStop.departureTime)), (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_13__/* .parseDate */ .s)("".concat(prevStop.arrivalDate, " ").concat(prevStop.arrivalTime)));
      parsedDetails.push(_objectSpread(_objectSpread({}, detail), {}, {
        departureAirportName: prevStop.airportName,
        departureAirportShortName: prevStop.airportShortName,
        departureAirportCode: prevStop.airportCode,
        departureDate: prevStop.departureDate,
        departureTime: prevStop.departureTime,
        arrivalAirportName: technicalStop.airportName,
        arrivalAirportShortName: technicalStop.airportShortName,
        arrivalAirportCode: technicalStop.airportCode,
        arrivalDate: technicalStop.arrivalDate,
        arrivalTime: technicalStop.arrivalTime,
        technicalStops: [],
        layover: layover,
        // duration: differenceInMinutes(
        //   `${technicalStop.arrivalDate} ${technicalStop.arrivalTime}`,
        //   `${prevStop.departureDate} ${prevStop.departureTime}`,
        // ),
        duration: 0
      }));
    }

    if (index === stopCount - 1) {
      // last
      var _layover = (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_13__/* .parseDate */ .s)("".concat(technicalStop.departureDate, " ").concat(technicalStop.departureTime)), (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_13__/* .parseDate */ .s)("".concat(technicalStop.arrivalDate, " ").concat(technicalStop.arrivalTime)));

      parsedDetails.push(_objectSpread(_objectSpread({}, detail), {}, {
        departureAirportName: technicalStop.airportName,
        departureAirportShortName: technicalStop.airportShortName,
        departureAirportCode: technicalStop.airportCode,
        departureDate: technicalStop.departureDate,
        departureTime: technicalStop.departureTime,
        technicalStops: [],
        layover: _layover,
        // duration: differenceInMinutes(
        //   `${detail.arrivalDate} ${detail.arrivalTime}`,
        //   `${technicalStop.departureDate} ${technicalStop.departureTime}`,
        // ),
        duration: 0
      }));
    }

    return technicalStop;
  });
  return parsedDetails;
} // Flight.FreeBaggage

var isFreeBaggageEmpty = function isFreeBaggageEmpty(freeBaggage) {
  return !!freeBaggage.text;
};
var itineraryIndexText = function itineraryIndexText(freeBaggage) {
  return Array.isArray(freeBaggage.itineraryIndex) ? freeBaggage.itineraryIndex.join(" + ") : String(freeBaggage.itineraryIndex);
};
function parseFreeBaggage(freeBaggageContent, t) {
  if (!freeBaggageContent || isFreeBaggageContentEmpty(freeBaggageContent) || Object.keys(freeBaggageContent).length === 0 && freeBaggageContent.constructor === Object) {
    return t("label:flight.noFreeBaggage");
  } else if (freeBaggageContent.notice === "no_information") {
    return t("label:flight.noFreeBaggageInformation");
  } else if (freeBaggageContent.detailType === "weight") {
    return t("label:flight.weightFreeBaggagePerPerson", {
      weight: freeBaggageContent.weight,
      weightUnit: freeBaggageContent.weightUnit
    });
  } else if (freeBaggageContent.detailType === "piece_weight") {
    return t("label:flight.quantityWeightFreeBaggagePerPerson", {
      weight: freeBaggageContent.weight,
      weightUnit: freeBaggageContent.weightUnit,
      quantity: freeBaggageContent.quantity
    });
  }

  return t("label:flight.quantityFreeBaggagePerPerson", {
    quantity: freeBaggageContent.quantity
  });
} // Flight.FreeBaggageContent

var isFreeBaggageContentEmpty = function isFreeBaggageContentEmpty(freeBaggageContent) {
  return !freeBaggageContent.detailType && !freeBaggageContent.notice;
}; // Flight.BaggageOption

var isBaggageOptionEmpty = function isBaggageOptionEmpty(baggageOption) {
  return !baggageOption.options || baggageOption.options.length === 0;
};

/***/ }),

/***/ 59960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ loadingSelector; },
/* harmony export */   "ES": function() { return /* binding */ flightItineraryOriginInputDataSelector; },
/* harmony export */   "IO": function() { return /* binding */ setFlightDestinationInputData; },
/* harmony export */   "JQ": function() { return /* binding */ flightItineraryOriginSuggestionsSelector; },
/* harmony export */   "QJ": function() { return /* binding */ setFlightItineraryOriginInputData; },
/* harmony export */   "Sw": function() { return /* binding */ setFlightItineraryDestinationInputData; },
/* harmony export */   "UD": function() { return /* binding */ flightSuggestionSlice; },
/* harmony export */   "bZ": function() { return /* binding */ flightOriginSuggestionsSelector; },
/* harmony export */   "d3": function() { return /* binding */ flightItineraryDestinationInputDataSelector; },
/* harmony export */   "fm": function() { return /* binding */ flightOriginInputDataSelector; },
/* harmony export */   "qH": function() { return /* binding */ setFlightOriginInputData; },
/* harmony export */   "tk": function() { return /* binding */ debouncedFetchFlightDestinationSuggestions; },
/* harmony export */   "ts": function() { return /* binding */ flightDestinationSuggestionsSelector; },
/* harmony export */   "zI": function() { return /* binding */ flightDestinationInputDataSelector; },
/* harmony export */   "zY": function() { return /* binding */ flightItineraryDestinationSuggestionsSelector; }
/* harmony export */ });
/* unused harmony exports fetchFlightDestinationSuggestions, errorsSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22222);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_FlightDestinationTypes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74618);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25968);






 // import { RootState } from "main/javascripts/store";



var key = "flightSuggestion";
var initialState = {
  flightOriginSuggestions: [],
  flightOriginInputData: null,
  flightDestinationSuggestions: [],
  flightDestinationInputData: null,
  flightItineraryOriginSuggestions: {},
  flightItineraryOriginInputData: {},
  flightItineraryDestinationSuggestions: {},
  flightItineraryDestinationInputData: {},
  loading: false,
  errors: null
};
/** Async **/

var fetchFlightDestinationSuggestions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchFlightDestinationSuggestions"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, type, index, text, included_code, excluded_code, exclude_airport, paramString, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params, type = args.type, index = args.index;
            text = params.text, included_code = params.included_code, excluded_code = params.excluded_code, exclude_airport = params.exclude_airport;
            paramString = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)({
              q: text,
              included_code: included_code,
              excluded_code: excluded_code,
              exclude_airport: exclude_airport
            }, {
              arrayFormat: "repeat"
            });
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_6__/* .PATH_SCOPE */ .j1, "/api/flights/origin_destinations/suggests.json?").concat(paramString);
            _context.next = 8;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().get(url);

          case 8:
            result = _context.sent;
            return _context.abrupt("return", {
              suggestions: result.data,
              type: type,
              index: index
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var debouncedFetchFlightDestinationSuggestions = function debouncedFetchFlightDestinationSuggestions(arg) {
  return function (dispatch) {
    return (0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .debounced */ .YD)(fetchFlightDestinationSuggestions, arg, dispatch);
  };
};
/** slice **/

var flightSuggestionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    setFlightOriginInputData: function setFlightOriginInputData(state, action) {
      state.flightOriginInputData = action.payload; // clear

      if (!action.payload.text) {
        state.flightOriginSuggestions = [];
      }
    },
    setFlightDestinationInputData: function setFlightDestinationInputData(state, action) {
      state.flightDestinationInputData = action.payload; // clear

      if (!action.payload.text) {
        state.flightDestinationSuggestions = [];
      }
    },
    setFlightItineraryOriginInputData: function setFlightItineraryOriginInputData(state, action) {
      var index = action.payload.index;
      state.flightItineraryOriginInputData[index] = action.payload.data; // clear

      if (!action.payload.data.text) {
        if (state.flightItineraryOriginSuggestions[index]) {
          state.flightItineraryOriginSuggestions[index] = [];
        }
      }
    },
    setFlightItineraryDestinationInputData: function setFlightItineraryDestinationInputData(state, action) {
      var index = action.payload.index;
      state.flightItineraryDestinationInputData[index] = action.payload.data; // clear

      if (!action.payload.data.text) {
        if (state.flightItineraryDestinationSuggestions[index]) {
          state.flightItineraryDestinationSuggestions[index] = [];
        }
      }
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchFlightDestinationSuggestions.fulfilled, function (state, action) {
      var index = action.payload.index;

      if (action.payload.type === main_javascripts_constants_FlightDestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .FlightDestinationTypes.origin */ .D.origin) {
        if (index === undefined) {
          state.flightOriginSuggestions = action.payload.suggestions;
        } else {
          state.flightItineraryOriginSuggestions[index] = action.payload.suggestions;
        }
      } else {
        if (index === undefined) {
          state.flightDestinationSuggestions = action.payload.suggestions;
        } else {
          state.flightItineraryDestinationSuggestions[index] = action.payload.suggestions;
        }
      }
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var flightOriginSuggestionsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightOriginSuggestions;
});
var flightDestinationSuggestionsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightDestinationSuggestions;
});
var flightOriginInputDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightOriginInputData;
});
var flightDestinationInputDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightDestinationInputData;
});
var flightItineraryOriginSuggestionsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)([stateSelector, function (state, index) {
  return index;
}], function (state, index) {
  return state.flightItineraryOriginSuggestions[index];
});
var flightItineraryDestinationSuggestionsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)([stateSelector, function (state, index) {
  return index;
}], function (state, index) {
  return state.flightItineraryDestinationSuggestions[index];
});
var flightItineraryOriginInputDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)([stateSelector, function (state, index) {
  return index;
}], function (state, index) {
  var _state$flightItinerar;

  return (_state$flightItinerar = state.flightItineraryOriginInputData) === null || _state$flightItinerar === void 0 ? void 0 : _state$flightItinerar[index];
});
var flightItineraryDestinationInputDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)([stateSelector, function (state, index) {
  return index;
}], function (state, index) {
  var _state$flightItinerar2;

  return (_state$flightItinerar2 = state.flightItineraryDestinationInputData) === null || _state$flightItinerar2 === void 0 ? void 0 : _state$flightItinerar2[index];
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var _flightSuggestionSlic = flightSuggestionSlice.actions,
    setFlightOriginInputData = _flightSuggestionSlic.setFlightOriginInputData,
    setFlightDestinationInputData = _flightSuggestionSlic.setFlightDestinationInputData,
    setFlightItineraryOriginInputData = _flightSuggestionSlic.setFlightItineraryOriginInputData,
    setFlightItineraryDestinationInputData = _flightSuggestionSlic.setFlightItineraryDestinationInputData;


/***/ }),

/***/ 71900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iL": function() { return /* binding */ adjustedAdvancedValuesSelector; },
  "rK": function() { return /* binding */ advancedConditionValuesSelector; },
  "o3": function() { return /* binding */ advancedSearchFormInitialValuesSelector; },
  "uI": function() { return /* binding */ convertSearchFlightFormValuesToParams; },
  "re": function() { return /* binding */ postSearchFlightCache; },
  "ID": function() { return /* binding */ searchFlightSlice; },
  "T9": function() { return /* binding */ setSearchFlightAdvancedConditionValues; },
  "uW": function() { return /* binding */ setSearchFlightConditionValues; },
  "gb": function() { return /* binding */ setSearchFlightSortConditionValues; },
  "vX": function() { return /* binding */ sortConditionValuesSelector; }
});

// UNUSED EXPORTS: conditionValuesSelector, errorsSelector, loadingSelector, shallEqualAdjustedAdvancedValuesSelector

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var es = __webpack_require__(22222);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./main/javascripts/api/AxiosWrapper.ts
var AxiosWrapper = __webpack_require__(46208);
// EXTERNAL MODULE: ./main/javascripts/utils/sliceUtil.ts
var sliceUtil = __webpack_require__(83119);
;// CONCATENATED MODULE: ./main/javascripts/constants/FlightConstants.ts
var MAX_SEARCH_FLIGHT_ITINERARY_COUNT = 6;
// EXTERNAL MODULE: ./main/javascripts/constants/FlightTypes.ts
var FlightTypes = __webpack_require__(45021);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSlice.ts
var flightSlice = __webpack_require__(55030);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/FlightPriceFilterBlock.tsx
var FlightPriceFilterBlock = __webpack_require__(23717);
// EXTERNAL MODULE: ./main/javascripts/slices/paramSlice.ts
var paramSlice = __webpack_require__(9195);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/utils/ObjectUtil.ts
var ObjectUtil = __webpack_require__(76614);
// EXTERNAL MODULE: ./main/javascripts/utils/googleAnalyticsUtil.ts
var googleAnalyticsUtil = __webpack_require__(48207);
;// CONCATENATED MODULE: ./main/javascripts/features/flight/searchFlightSlice.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var key = "searchFlight";
var initialState = {
  conditionValues: {},
  advancedConditionValues: {},
  sortConditionValues: "",
  loading: false,
  errors: null
};
/** Async **/

var postSearchFlightCache = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(key, "/postSearchFlightCache"), /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, dynamicPackageId, searchGroupId, url, utmValues, requestParams, result;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params, dynamicPackageId = args.dynamicPackageId, searchGroupId = args.searchGroupId;
            url = "".concat(Constants/* PATH_SCOPE */.j1, "/api/search_flight/cache");
            utmValues = (0,googleAnalyticsUtil/* getUtmValues */.A)();
            requestParams = _objectSpread(_objectSpread({}, utmValues), params);
            _context.next = 8;
            return (0,AxiosWrapper/* createWrapper */.K)().post(url, (0,humps.decamelizeKeys)({
              conditions: requestParams,
              dynamicPackageId: dynamicPackageId,
              searchGroupId: searchGroupId
            }));

          case 8:
            result = _context.sent;
            return _context.abrupt("return", {
              data: result.data
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps.camelizeKeys)(_context.t0.response.data)));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/** slice **/

var searchFlightSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: key,
  initialState: initialState,
  reducers: {
    setSearchFlightConditionValues: function setSearchFlightConditionValues(state, action) {
      state.conditionValues = action.payload;
    },
    setSearchFlightAdvancedConditionValues: function setSearchFlightAdvancedConditionValues(state, action) {
      // read onlyエラーが発生することがあるためcloneする
      // フォームの値を直接stateに入れてしまうとimmerによりread onlyに変更され
      // 次のフォーム更新時にエラーになったと想定している
      state.advancedConditionValues = (0,ObjectUtil/* clone */.d9)(action.payload);
    },
    setSearchFlightSortConditionValues: function setSearchFlightSortConditionValues(state, action) {
      state.sortConditionValues = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder // 一旦slice単位で共通化
    .addMatcher((0,sliceUtil/* isPendingAction */.zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,sliceUtil/* isFulfilledAction */.ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,sliceUtil/* isRejectedAction */._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var conditionValuesSelector = (0,es/* createSelector */.P1)(stateSelector, function (state) {
  return state.conditionValues;
});
var advancedConditionValuesSelector = (0,es/* createSelector */.P1)(stateSelector, function (state) {
  return state.advancedConditionValues;
});
var sortConditionValuesSelector = (0,es/* createSelector */.P1)(stateSelector, function (state) {
  return state.sortConditionValues;
});
var errorsSelector = (0,es/* createSelector */.P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,es/* createSelector */.P1)(stateSelector, function (state) {
  return state.loading;
});
var shallEqualAdjustedAdvancedValuesSelector = (0,es/* createSelector */.P1)(conditionValuesSelector, advancedConditionValuesSelector, flightSlice/* airlinesSelector */.ZF, flightSlice/* departureAirportsSelector */.VV, flightSlice/* transitAirportsSelector */.Q6, function (formValues, advancedFormValues, airlines, departureAirports, transitAirports) {
  if (!advancedFormValues) {
    return advancedFormValues;
  }

  var airlineCodes = (airlines || []).map(function (airline) {
    return airline.code;
  });
  var departureAirportCodes = (departureAirports || []).map(function (airport) {
    return airport.code;
  });
  var transitAirportCodes = (transitAirports || []).map(function (airport) {
    return airport.code;
  });
  var filteredAirlines = advancedFormValues.airline_codes ? advancedFormValues.airline_codes.filter(function (code) {
    return airlineCodes.includes(code);
  }) : advancedFormValues.airline_codes;
  var filteredDepartureAirports = advancedFormValues.departure_airport_codes ? advancedFormValues.departure_airport_codes.filter(function (code) {
    return departureAirportCodes.includes(code);
  }) : advancedFormValues.departure_airport_codes;
  var filteredTransitAirports = advancedFormValues.transit_airport_codes ? advancedFormValues.transit_airport_codes.filter(function (code) {
    return transitAirportCodes.includes(code);
  }) : advancedFormValues.transit_airport_codes;

  var values = _objectSpread(_objectSpread({}, advancedFormValues), {}, {
    airline_codes: filteredAirlines,
    departure_airport_codes: filteredDepartureAirports,
    transit_airport_codes: filteredTransitAirports
  });

  var flightType = formValues.flight_type; // tslint:disable-next-line:prefer-array-literal

  Array.from(Array(MAX_SEARCH_FLIGHT_ITINERARY_COUNT).keys()).map(function (_, index) {
    var departure_hour = values["departure_hour".concat(index + 1)];

    if (departure_hour) {
      if (flightType === FlightTypes/* FlightTypes.oneWay */.z.oneWay || flightType === FlightTypes/* FlightTypes.roundTrip */.z.roundTrip && index > 0 || flightType === FlightTypes/* FlightTypes.multiCity */.z.multiCity && index + 1 >= formValues.itineraries.count) {
        delete values["departure_hour".concat(index + 1)];
      }
    }

    return false;
  });
  return values;
}); // DeepEqualで変更をチェックする
// createSelectorの比較は引数で渡すselectorsに対して実施されるようなので
// 計算結果を比較させるためにshallEqualAdjustedAdvancedValuesSelectorをラップしている

var adjustedAdvancedValuesSelector = (0,sliceUtil/* createDeepEqualSelector */.C6)(shallEqualAdjustedAdvancedValuesSelector, function (values) {
  return values;
});
var advancedSearchFormInitialValuesSelector = (0,es/* createSelector */.P1)(paramSlice/* flightIndexParamSelector */.XI, function (param) {
  var initialDepartureHour = {
    from: 0,
    to: 24
  };

  var hourInitialValues = function hourInitialValues() {
    return {
      departure_hour1: param.departureHour1 && Object.keys(param.departureHour1).length ? param.departureHour1 : initialDepartureHour,
      departure_hour2: param.departureHour2 && Object.keys(param.departureHour2).length ? param.departureHour2 : initialDepartureHour,
      departure_hour3: param.departureHour3 && Object.keys(param.departureHour3).length ? param.departureHour3 : initialDepartureHour,
      departure_hour4: param.departureHour4 && Object.keys(param.departureHour4).length ? param.departureHour4 : initialDepartureHour,
      departure_hour5: param.departureHour5 && Object.keys(param.departureHour5).length ? param.departureHour5 : initialDepartureHour,
      last_departure_hour: param.lastDepartureHour && Object.keys(param.lastDepartureHour).length ? param.lastDepartureHour : initialDepartureHour,
      last_arrival_hour: param.lastArrivalHour && Object.keys(param.lastArrivalHour).length ? param.lastArrivalHour : initialDepartureHour,
      min_layover: param.minLayover || param.minLayover === 0 ? param.minLayover : null,
      max_layover: param.maxLayover || param.maxLayover === 0 ? param.maxLayover : null
    };
  };

  return _objectSpread(_objectSpread({
    min_price: param.minPrice ? param.minPrice : FlightPriceFilterBlock/* initialMinPrice */.fM,
    max_price: param.maxPrice ? param.maxPrice : FlightPriceFilterBlock/* initialMaxPrice */.wO,
    max_stop: param.maxStop != null ? String(param.maxStop) : null
  }, hourInitialValues()), {}, {
    airline_codes: param.airlineCodes ? param.airlineCodes : [],
    departure_airport_codes: param.departureAirportCodes ? param.departureAirportCodes : [],
    transit_airport_codes: param.transitAirportCodes ? param.transitAirportCodes : [],
    free_baggage_type: param.freeBaggageType ? param.freeBaggageType : null,
    not_use_lcc: !!param.notUseLcc
  });
});
/** action export **/

var _searchFlightSlice$ac = searchFlightSlice.actions,
    setSearchFlightConditionValues = _searchFlightSlice$ac.setSearchFlightConditionValues,
    setSearchFlightAdvancedConditionValues = _searchFlightSlice$ac.setSearchFlightAdvancedConditionValues,
    setSearchFlightSortConditionValues = _searchFlightSlice$ac.setSearchFlightSortConditionValues;

var convertSearchFlightFormValuesToParams = function convertSearchFlightFormValuesToParams(data) {
  var _params$traveler;

  var params = (0,ObjectUtil/* clone */.d9)(data);

  if (params.flight_type === FlightTypes/* FlightTypes.multiCity */.z.multiCity) {
    delete params.departure_date;
    delete params.return_date;
  } else if (params.flight_type === FlightTypes/* FlightTypes.oneWay */.z.oneWay) {
    delete params.return_date;
    delete params.itineraries;
  } else {
    delete params.itineraries;
  }

  var agesOfChildren = (_params$traveler = params.traveler) === null || _params$traveler === void 0 ? void 0 : _params$traveler.ages_of_children;

  if (agesOfChildren && agesOfChildren.length > 0) {
    params.traveler.ages_of_children = agesOfChildren.map(function (age) {
      return age.age;
    });
  } else {
    var _params$traveler2;

    (_params$traveler2 = params.traveler) === null || _params$traveler2 === void 0 ? true : delete _params$traveler2.ages_of_children;
  }

  return params;
};

/***/ }),

/***/ 74659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ convertHotelSearchFormValuesToParams; },
/* harmony export */   "Ao": function() { return /* binding */ defaultHotelRoomImage; },
/* harmony export */   "By": function() { return /* binding */ hotelsSelector; },
/* harmony export */   "CQ": function() { return /* binding */ setHotelRoomModalDetails; },
/* harmony export */   "E2": function() { return /* binding */ loadingSelector; },
/* harmony export */   "GM": function() { return /* binding */ hotelIdSelector; },
/* harmony export */   "GP": function() { return /* binding */ hotelSlice; },
/* harmony export */   "Hp": function() { return /* binding */ isDisplayedImageModalSelector; },
/* harmony export */   "I0": function() { return /* binding */ selectedHotelPlanSelector; },
/* harmony export */   "Id": function() { return /* binding */ isPollingSelector; },
/* harmony export */   "KD": function() { return /* binding */ numPerPageSelector; },
/* harmony export */   "LE": function() { return /* binding */ isPollingCompletedSelector; },
/* harmony export */   "LG": function() { return /* binding */ setHotelMapCoordinates; },
/* harmony export */   "NO": function() { return /* binding */ setIsHotelMapView; },
/* harmony export */   "OF": function() { return /* binding */ hotelImagesSelector; },
/* harmony export */   "Q0": function() { return /* binding */ fetchHotelsForMap; },
/* harmony export */   "RC": function() { return /* binding */ fetchHotels; },
/* harmony export */   "RN": function() { return /* binding */ setDisplayHotelRoomDetailModal; },
/* harmony export */   "S4": function() { return /* binding */ setPollingCondition; },
/* harmony export */   "T": function() { return /* binding */ hotelsForMapSelector; },
/* harmony export */   "Ui": function() { return /* binding */ roomDetailModalDataSelector; },
/* harmony export */   "WS": function() { return /* binding */ isDisplayedSearchFormSelector; },
/* harmony export */   "XS": function() { return /* binding */ hotelSelector; },
/* harmony export */   "Xb": function() { return /* binding */ setRequestRoomError; },
/* harmony export */   "ZH": function() { return /* binding */ initHotel; },
/* harmony export */   "Zx": function() { return /* binding */ isShowMapViewSelector; },
/* harmony export */   "_p": function() { return /* binding */ pageSelector; },
/* harmony export */   "aF": function() { return /* binding */ requestRoomErrorSelector; },
/* harmony export */   "av": function() { return /* binding */ setDisplayHotelRoomImageModal; },
/* harmony export */   "dQ": function() { return /* binding */ setDisplayHotelImageModal; },
/* harmony export */   "if": function() { return /* binding */ setDisplayHotelSearchForm; },
/* harmony export */   "lH": function() { return /* binding */ initHotels; },
/* harmony export */   "mX": function() { return /* binding */ isDisplayedRoomDetailModalSelector; },
/* harmony export */   "q0": function() { return /* binding */ isLoadingRoomSelector; },
/* harmony export */   "qN": function() { return /* binding */ fetchHotelRooms; },
/* harmony export */   "rN": function() { return /* binding */ totalNumSelector; },
/* harmony export */   "ug": function() { return /* binding */ selectedHotelRoomSelector; },
/* harmony export */   "zj": function() { return /* binding */ setIsLoadingRoom; },
/* harmony export */   "zz": function() { return /* binding */ descendingRegionsSelector; }
/* harmony export */ });
/* unused harmony exports fetchHotelsIndexPage, fetchHotelsShowPage, hotelByIdSelector, hotelIdsSelector, hotelEntitiesSelector, totalHotelsSelector, roomImageModalDataSelector, isDisplayedRoomImageModalSelector, errorsSelector, setHotelRooms */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12902);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22222);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9195);
/* harmony import */ var _manager_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11166);











var key = "hotel";
var adapter = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createEntityAdapter */ .HF)();
var adapterForMap = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createEntityAdapter */ .HF)();
var MAX_UPDATED_HOTEL_COUNT =  true ? 60 : 0;
var initialState = adapter.getInitialState({
  hotelsForMap: adapterForMap.getInitialState(),
  hotel: null,
  hotelId: 0,
  page: 0,
  numPerPage: 0,
  totalNum: 0,
  updatedHotelCount: 0,
  isPolling: false,
  isPollingCompleted: false,
  pollingCondition: null,
  descendingRegions: null,
  // 空の場合があるため未取得はnullにする
  isShowMapView: false,
  hotelIdsForMap: [],
  isPollingForMap: false,
  totalNumForMap: 0,
  mapCenterCoordinates: {},
  isDisplayedSearchForm: false,
  isDisplayedImageModal: false,
  isDisplayedRoomImageModal: false,
  roomImageModalData: {},
  isDisplayedRoomDetailModal: false,
  roomDetailModalData: {},
  isLoadingRoom: false,
  requestRoomError: null,
  loading: false,
  errors: null
});
/** Async **/

var fetchHotelsIndexPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchHotelsIndexPage"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, _args$isServerSide, isServerSide, headers, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? false : _args$isServerSide, headers = args.headers;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/page/hotels.json?".concat(param);
            _context.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_4__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 7:
            result = _context.sent;
            return _context.abrupt("return", {
              param: result.data.param,
              hotels: result.data.hotels,
              numPerPage: result.data.numPerPage,
              page: result.data.page,
              totalNum: result.data.totalNum,
              dynamicPackagePreReservation: result.data.dynamicPackagePreReservation,
              facebookAppId: result.data.facebookAppId || ""
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var fetchHotelsShowPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchHotelsShowPage"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, id, params, _args$isServerSide2, isServerSide, headers, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            id = args.id, params = args.params, _args$isServerSide2 = args.isServerSide, isServerSide = _args$isServerSide2 === void 0 ? false : _args$isServerSide2, headers = args.headers;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/page/hotels/".concat(id, ".json?").concat(param);
            _context2.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_4__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 7:
            result = _context2.sent;
            return _context2.abrupt("return", {
              hotel: result.data.hotel,
              param: result.data.param,
              facebookAppId: result.data.facebookAppId || ""
            });

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context2.t0.response.data)));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}()); // ポーリングする場合は必ず事前にsetPollingConditionを実施すること

var fetchHotels = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchHotels"), /*#__PURE__*/function () {
  var _ref6 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(args, _ref5) {
    var rejectWithValue, params, _args$isPollingReques, isPollingRequest, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue;
            _context3.prev = 1;
            params = args.params, _args$isPollingReques = args.isPollingRequest, isPollingRequest = _args$isPollingReques === void 0 ? false : _args$isPollingReques;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/hotels.json?".concat(param);
            _context3.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_4__/* .createWrapper */ .K)().get(url);

          case 7:
            result = _context3.sent;
            return _context3.abrupt("return", {
              hotels: result.data.hotels,
              isPolling: result.data.isPolling,
              page: result.data.page,
              numPerPage: result.data.numPerPage,
              totalNum: result.data.totalNum,
              descendingRegions: result.data.descendingRegions,
              isPollingRequest: isPollingRequest,
              params: params
            });

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context3.t0.response.data)));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 11]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
var fetchHotelsForMap = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchHotelsForMap"), /*#__PURE__*/function () {
  var _ref8 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(args, _ref7) {
    var rejectWithValue, params, isPollingRequest, param, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            rejectWithValue = _ref7.rejectWithValue;
            _context4.prev = 1;
            params = args.params, isPollingRequest = args.isPollingRequest;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/hotels.json?".concat(param);
            _context4.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_4__/* .createWrapper */ .K)().get(url);

          case 7:
            result = _context4.sent;
            return _context4.abrupt("return", {
              hotels: result.data.hotels,
              isPolling: result.data.isPolling,
              page: result.data.page,
              numPerPage: result.data.numPerPage,
              totalNum: result.data.totalNum,
              descendingRegions: result.data.descendingRegions,
              isPollingRequest: isPollingRequest,
              params: params
            });

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context4.t0.response.data)));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 11]]);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}());
var fetchHotelRooms = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchHotelRooms"), /*#__PURE__*/function () {
  var _ref10 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(args, _ref9) {
    var rejectWithValue, hotelId, _args$param, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            rejectWithValue = _ref9.rejectWithValue;
            _context5.prev = 1;
            hotelId = args.hotelId, _args$param = args.param, param = _args$param === void 0 ? false : _args$param;
            url = "/api/hotels/".concat(hotelId, "/hotel_rooms.json?").concat(param);
            _context5.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_4__/* .createWrapper */ .K)().get(url);

          case 6:
            result = _context5.sent;
            return _context5.abrupt("return", {
              hotelRooms: result.data.hotelRooms,
              roomCacheId: result.data.roomCacheId,
              hotelId: hotelId
            });

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context5.t0.response.data)));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 10]]);
  }));

  return function (_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}());
/** slice **/

var hotelSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initHotel: function initHotel(state, action) {
      state.hotelId = action.payload.id;
      state.hotel = action.payload;
    },
    initHotels: function initHotels(state, action) {
      adapter.setAll(state, action.payload.hotels || []);
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
      state.totalNum = action.payload.totalNum;
    },
    setHotelRooms: function setHotelRooms(state, action) {
      state.hotelId = action.payload.hotelId;
      var hotel = state.hotel;
      hotel.hotelRooms = action.payload.hotelRooms;
      state.hotel = hotel;
    },
    setIsHotelMapView: function setIsHotelMapView(state, action) {
      state.isShowMapView = action.payload;
    },
    setHotelMapCoordinates: function setHotelMapCoordinates(state, action) {
      state.mapCenterCoordinates = action.payload;
    },
    setDisplayHotelSearchForm: function setDisplayHotelSearchForm(state, action) {
      state.isDisplayedSearchForm = action.payload;
    },
    setDisplayHotelImageModal: function setDisplayHotelImageModal(state, action) {
      state.isDisplayedImageModal = action.payload;
    },
    setDisplayHotelRoomImageModal: function setDisplayHotelRoomImageModal(state, action) {
      state.isDisplayedRoomImageModal = action.payload;
    },
    setDisplayHotelRoomDetailModal: function setDisplayHotelRoomDetailModal(state, action) {
      state.isDisplayedRoomDetailModal = action.payload;
    },
    setHotelRoomModalDetails: function setHotelRoomModalDetails(state, action) {
      state.roomDetailModalData = action.payload;
    },
    setIsLoadingRoom: function setIsLoadingRoom(state, action) {
      state.isLoadingRoom = action.payload;
    },
    setRequestRoomError: function setRequestRoomError(state, action) {
      state.requestRoomError = action.payload;
    },
    setPollingCondition: function setPollingCondition(state, action) {
      state.pollingCondition = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchHotels.pending, function (state) {
      state.isPolling = true;
      state.isPollingCompleted = false;
      state.updatedHotelCount = 0;
    }).addCase(fetchHotels.fulfilled, function (state, action) {
      // ポーリングの場合paramsが異なるアクションは無視する
      var isPollingRequest = action.payload.isPollingRequest;
      var currentCondition = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .removeEmpty */ .HO)((0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .current */ .Vk)(state.pollingCondition));
      var params = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .removeEmpty */ .HO)(action.payload.params);

      if (isPollingRequest && !react_fast_compare__WEBPACK_IMPORTED_MODULE_3___default()(currentCondition, params)) {
        return;
      }

      adapter.setAll(state, action.payload.hotels || []);
      var updatedHotelCount = state.updatedHotelCount > MAX_UPDATED_HOTEL_COUNT ? 0 : state.updatedHotelCount + 1;
      var isPolling = updatedHotelCount === 0 ? false : action.payload.isPolling;
      state.isPolling = isPolling;
      state.isPollingCompleted = !isPolling;
      state.page = action.payload.page; // state.numPerPage = action.payload.numPerPage;

      state.totalNum = action.payload.totalNum;
      state.descendingRegions = action.payload.descendingRegions;
      state.updatedHotelCount = updatedHotelCount;
    }).addCase(fetchHotels.rejected, function (state, _action) {
      state.isPolling = false;
      state.isPollingCompleted = true;
      state.page = 1;
    }).addCase(fetchHotelsForMap.pending, function (state) {
      state.isPollingForMap = true;
    }).addCase(fetchHotelsForMap.fulfilled, function (state, action) {
      // ポーリングの場合paramsが異なるアクションは無視する
      var isPollingRequest = action.payload.isPollingRequest;
      var currentCondition = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .removeEmpty */ .HO)((0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .current */ .Vk)(state.pollingCondition));
      var params = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_9__/* .removeEmpty */ .HO)(action.payload.params);

      if (isPollingRequest && !react_fast_compare__WEBPACK_IMPORTED_MODULE_3___default()(currentCondition, params)) {
        return;
      }

      adapterForMap.setAll(state.hotelsForMap, action.payload.hotels);
      state.isPollingForMap = action.payload.isPolling;
      state.page = action.payload.page;
      state.totalNumForMap = action.payload.totalNum;
      state.descendingRegions = action.payload.descendingRegions;
    }).addCase(fetchHotelRooms.fulfilled, function (state, action) {
      state.hotelId = action.payload.hotelId;
      var hotel = state.hotel;
      hotel.hotelRooms = action.payload.hotelRooms;
      state.hotel = hotel;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_5__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_5__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_5__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var _adapter$getSelectors = adapter.getSelectors(function (state) {
  return state.hotel;
}),
    hotelByIdSelector = _adapter$getSelectors.selectById,
    hotelIdsSelector = _adapter$getSelectors.selectIds,
    hotelEntitiesSelector = _adapter$getSelectors.selectEntities,
    hotelsSelector = _adapter$getSelectors.selectAll,
    totalHotelsSelector = _adapter$getSelectors.selectTotal;



var _adapterForMap$getSel = adapterForMap.getSelectors(function (state) {
  return state.hotel.hotelsForMap;
}),
    hotelsForMapSelector = _adapterForMap$getSel.selectAll;



var stateSelector = function stateSelector(state) {
  return state[key];
};

var hotelSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotel;
});
var hotelIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelId;
});
var hotelImagesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotel.hotelImages;
});
var pageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.page;
});
var numPerPageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.numPerPage;
});
var totalNumSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.totalNum;
});
var isPollingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isPolling;
});
var isPollingCompletedSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isPollingCompleted;
});
var descendingRegionsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.descendingRegions;
});
var isShowMapViewSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isShowMapView;
});
var isDisplayedSearchFormSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isDisplayedSearchForm;
});
var isDisplayedImageModalSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isDisplayedImageModal;
});
var roomImageModalDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.roomImageModalData;
});
var isDisplayedRoomImageModalSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isDisplayedRoomImageModal;
});
var roomDetailModalDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.roomDetailModalData;
});
var isDisplayedRoomDetailModalSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isDisplayedRoomDetailModal;
});
var isLoadingRoomSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.isLoadingRoom;
});
var requestRoomErrorSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.requestRoomError;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
var selectedHotelRoomSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(hotelSelector, main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_6__/* .hotelShowParamHotelRoomIdSelector */ .lg, function (hotel, hotelRoomId) {
  var _hotel$hotelRooms;

  if (!hotel) {
    return;
  } // hotelRoom.idはstringで扱う


  return (_hotel$hotelRooms = hotel.hotelRooms) === null || _hotel$hotelRooms === void 0 ? void 0 : _hotel$hotelRooms.find(function (hotelRoom) {
    return hotelRoom.id === hotelRoomId;
  });
});
var selectedHotelPlanSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(selectedHotelRoomSelector, main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_6__/* .hotelShowParamHotelPlanIdSelector */ .zJ, function (hotelRoom, hotelPlanId) {
  var _hotelRoom$hotelPlans;

  if (!hotelRoom) {
    return;
  } // hotelPlan.idはstringで扱う


  return (_hotelRoom$hotelPlans = hotelRoom.hotelPlans) === null || _hotelRoom$hotelPlans === void 0 ? void 0 : _hotelRoom$hotelPlans.find(function (hotelPlan) {
    return String(hotelPlan.id) === hotelPlanId;
  });
});
/** action export **/

var _hotelSlice$actions = hotelSlice.actions,
    initHotel = _hotelSlice$actions.initHotel,
    initHotels = _hotelSlice$actions.initHotels,
    setHotelRooms = _hotelSlice$actions.setHotelRooms,
    setIsHotelMapView = _hotelSlice$actions.setIsHotelMapView,
    setHotelMapCoordinates = _hotelSlice$actions.setHotelMapCoordinates,
    setDisplayHotelSearchForm = _hotelSlice$actions.setDisplayHotelSearchForm,
    setDisplayHotelImageModal = _hotelSlice$actions.setDisplayHotelImageModal,
    setDisplayHotelRoomImageModal = _hotelSlice$actions.setDisplayHotelRoomImageModal,
    setDisplayHotelRoomDetailModal = _hotelSlice$actions.setDisplayHotelRoomDetailModal,
    setHotelRoomModalDetails = _hotelSlice$actions.setHotelRoomModalDetails,
    setIsLoadingRoom = _hotelSlice$actions.setIsLoadingRoom,
    setRequestRoomError = _hotelSlice$actions.setRequestRoomError,
    setPollingCondition = _hotelSlice$actions.setPollingCondition; // Hotel.Room


var defaultHotelRoomImage = function defaultHotelRoomImage(hotelRoom) {
  var defaultImage = hotelRoom.hotelRoomImages.find(function (img) {
    return img.isDefault;
  });
  return defaultImage ? defaultImage : hotelRoom.hotelRoomImages[0];
};
var convertHotelSearchFormValuesToParams = function convertHotelSearchFormValuesToParams(data) {
  var _params$guests;

  var params = (0,_manager_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_12__/* .clone */ .d9)(data);

  if (((_params$guests = params.guests) === null || _params$guests === void 0 ? void 0 : _params$guests.length) > 0) {
    params.guests.map(function (guest, index) {
      if (Number(guest.number_of_children) > 0) {
        params.guests[index].ages_of_children = guest.ages_of_children.map(function (age) {
          return age.age;
        });
      } else {
        delete params.guests[index].ages_of_children;
      }
    });
  }

  return params;
};

/***/ }),

/***/ 86058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ loadingSelector; },
/* harmony export */   "Hx": function() { return /* binding */ setHotelDestinationInputData; },
/* harmony export */   "TW": function() { return /* binding */ hotelDestinationInputDataSelector; },
/* harmony export */   "s0": function() { return /* binding */ hotelDestinationSuggestionsSelector; },
/* harmony export */   "tj": function() { return /* binding */ hotelSuggestionSlice; },
/* harmony export */   "y$": function() { return /* binding */ debouncedFetchHotelDestinationSuggestions; }
/* harmony export */ });
/* unused harmony exports fetchHotelDestinationSuggestions, errorsSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22222);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);






 // import { RootState } from "main/javascripts/store";


var key = "hotelSuggestion";
var initialState = {
  hotelDestinationSuggestions: [],
  hotelDestinationInputData: null,
  loading: false,
  errors: null
};
/** Async **/

var fetchHotelDestinationSuggestions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchHotelDestinationSuggestions"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, text, included_code, excluded_code, paramString, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params;
            text = params.text, included_code = params.included_code, excluded_code = params.excluded_code;
            paramString = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)({
              q: text,
              included_code: included_code,
              excluded_code: excluded_code
            }, {
              arrayFormat: "repeat"
            });
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/hotels/destinations/suggests.json?").concat(paramString);
            _context.next = 8;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().get(url);

          case 8:
            result = _context.sent;
            return _context.abrupt("return", {
              suggestions: result.data
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var debouncedFetchHotelDestinationSuggestions = function debouncedFetchHotelDestinationSuggestions(arg) {
  return function (dispatch) {
    return (0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .debounced */ .YD)(fetchHotelDestinationSuggestions, arg, dispatch);
  };
};
/** slice **/

var hotelSuggestionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    setHotelDestinationInputData: function setHotelDestinationInputData(state, action) {
      state.hotelDestinationInputData = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchHotelDestinationSuggestions.fulfilled, function (state, action) {
      state.hotelDestinationSuggestions = action.payload.suggestions;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var hotelDestinationSuggestionsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelDestinationSuggestions;
});
var hotelDestinationInputDataSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelDestinationInputData;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var setHotelDestinationInputData = hotelSuggestionSlice.actions.setHotelDestinationInputData;


/***/ }),

/***/ 9296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dh": function() { return /* binding */ convertSearchHotelFormValuesToParams; },
/* harmony export */   "E2": function() { return /* binding */ loadingSelector; },
/* harmony export */   "Rd": function() { return /* binding */ searchHotelSlice; },
/* harmony export */   "Yw": function() { return /* binding */ postSearchHotelCache; },
/* harmony export */   "ZM": function() { return /* binding */ setSearchHotelSortConditionValues; },
/* harmony export */   "iL": function() { return /* binding */ adjustedAdvancedValuesSelector; },
/* harmony export */   "o3": function() { return /* binding */ advancedSearchFormInitialValuesSelector; },
/* harmony export */   "rK": function() { return /* binding */ advancedConditionValuesSelector; },
/* harmony export */   "vX": function() { return /* binding */ sortConditionValuesSelector; },
/* harmony export */   "zF": function() { return /* binding */ setSearchHotelAdvancedConditionValues; }
/* harmony export */ });
/* unused harmony exports conditionValuesSelector, errorsSelector, setSearchHotelConditionValues */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);
/* harmony import */ var _hotelSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74659);
/* harmony import */ var main_javascripts_components_molecules_Form_HotelPriceFilterBlock_HotelPriceFilterBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3559);
/* harmony import */ var main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9195);
/* harmony import */ var main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76614);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25968);
/* harmony import */ var _utils_googleAnalyticsUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48207);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




 // import { RootState } from "main/javascripts/store";








var key = "searchHotel";
var initialState = {
  conditionValues: {},
  advancedConditionValues: {},
  sortConditionValues: "",
  loading: false,
  errors: null
};
/** Async **/

var postSearchHotelCache = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("".concat(key, "/postSearchHotelCache"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, dynamicPackageId, searchGroupId, url, utmValues, requestParams, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params, dynamicPackageId = args.dynamicPackageId, searchGroupId = args.searchGroupId;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_8__/* .PATH_SCOPE */ .j1, "/api/search_hotel/cache");
            utmValues = (0,_utils_googleAnalyticsUtil__WEBPACK_IMPORTED_MODULE_9__/* .getUtmValues */ .A)();
            requestParams = _objectSpread(_objectSpread({}, utmValues), params);
            _context.next = 8;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().post(url, (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
              conditions: requestParams,
              dynamicPackageId: dynamicPackageId,
              searchGroupId: searchGroupId
            }));

          case 8:
            result = _context.sent;
            return _context.abrupt("return", {
              data: result.data
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/** slice **/

var searchHotelSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    setSearchHotelConditionValues: function setSearchHotelConditionValues(state, action) {
      state.conditionValues = action.payload;
    },
    setSearchHotelAdvancedConditionValues: function setSearchHotelAdvancedConditionValues(state, action) {
      // read onlyエラーが発生することがあるためcloneする
      // フォームの値を直接stateに入れてしまうとimmerによりread onlyに変更され
      // 次のフォーム更新時にエラーになったと想定している
      state.advancedConditionValues = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_12__/* .clone */ .d9)(action.payload);
    },
    setSearchHotelSortConditionValues: function setSearchHotelSortConditionValues(state, action) {
      state.sortConditionValues = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var conditionValuesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.conditionValues;
});
var advancedConditionValuesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.advancedConditionValues;
});
var sortConditionValuesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.sortConditionValues;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
var adjustedAdvancedValuesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(advancedConditionValuesSelector, _hotelSlice__WEBPACK_IMPORTED_MODULE_5__/* .descendingRegionsSelector */ .zz, function (advancedFormValues, descendingRegions) {
  if (!advancedFormValues || (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_12__/* .isObjectEmpty */ .nK)(advancedFormValues)) {
    return advancedFormValues;
  }

  var descendingRegionIds = (descendingRegions || []).map(function (region) {
    return String(region.id);
  });
  var filteredDescendingRegions = advancedFormValues.descending_region_ids ? advancedFormValues.descending_region_ids.filter(function (id) {
    return descendingRegionIds.includes(id);
  }) : advancedFormValues.descending_region_ids;
  return _objectSpread(_objectSpread({}, advancedFormValues), {}, {
    descending_region_ids: filteredDescendingRegions
  });
});
var advancedSearchFormInitialValuesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_13__/* .createSelector */ .P1)(main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_7__/* .hotelIndexParamSelector */ .OJ, function (param) {
  return {
    min_price: param.minPrice ? param.minPrice : main_javascripts_components_molecules_Form_HotelPriceFilterBlock_HotelPriceFilterBlock__WEBPACK_IMPORTED_MODULE_6__/* .initialMinPrice */ .fM,
    max_price: param.maxPrice ? param.maxPrice : main_javascripts_components_molecules_Form_HotelPriceFilterBlock_HotelPriceFilterBlock__WEBPACK_IMPORTED_MODULE_6__/* .initialMaxPrice */ .wO,
    min_rating: param.minRating ? param.minRating : null,
    rank: param.rank ? param.rank : null,
    bed_count: param.bedCount ? param.bedCount : null,
    bed_size_types: param.bedSizeTypes ? param.bedSizeTypes : null,
    meal_type: param.mealType ? param.mealType : null,
    view_type: param.viewType ? param.viewType : null,
    descending_region_ids: param.descendingRegionIds ? param.descendingRegionIds : null
  };
});
/** action export **/

var _searchHotelSlice$act = searchHotelSlice.actions,
    setSearchHotelConditionValues = _searchHotelSlice$act.setSearchHotelConditionValues,
    setSearchHotelAdvancedConditionValues = _searchHotelSlice$act.setSearchHotelAdvancedConditionValues,
    setSearchHotelSortConditionValues = _searchHotelSlice$act.setSearchHotelSortConditionValues;

var convertSearchHotelFormValuesToParams = function convertSearchHotelFormValuesToParams(data) {
  var _params$guests;

  var params = (0,main_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_12__/* .clone */ .d9)(data);

  if (((_params$guests = params.guests) === null || _params$guests === void 0 ? void 0 : _params$guests.length) > 0) {
    params.guests.map(function (guest, index) {
      if (Number(guest.number_of_children) > 0) {
        params.guests[index].ages_of_children = guest.ages_of_children.map(function (age) {
          return age.age;
        });
      } else {
        delete params.guests[index].ages_of_children;
      }
    });
  }

  return params;
};

/***/ }),

/***/ 95698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Di": function() { return /* binding */ destinationTypeForSearch; },
/* harmony export */   "O4": function() { return /* binding */ initFlightDestination; },
/* harmony export */   "cb": function() { return /* binding */ originTypeForSearch; },
/* harmony export */   "oc": function() { return /* binding */ flightDestinationRegionSelector; },
/* harmony export */   "pU": function() { return /* binding */ lpFlightDstRegionSlice; }
/* harmony export */ });
/* unused harmony exports fetchLpFlightDstRegionsShowPage, errorsSelector, loadingSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83119);






var key = "lpFlightDstRegion";
var initialState = {
  flightDestinationRegion: null,
  metaTags: null,
  loading: false,
  errors: null
};
/** Async **/

var fetchLpFlightDstRegionsShowPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchLpFlightDstRegionsShowPage"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, id, param, _args$isServerSide, isServerSide, headers, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            id = args.id, param = args.param, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? false : _args$isServerSide, headers = args.headers;
            url = "/api/page/lp/flights/dst_regions/".concat(id, ".json?").concat(param);
            _context.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 6:
            result = _context.sent;
            return _context.abrupt("return", {
              flightDestinationRegion: result.data.flightDestinationRegion,
              metaTags: result.data.metaTags
            });

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context.t0.response.data)));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/** slice **/

var lpFlightDstRegionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initFlightDestination: function initFlightDestination(state, action) {
      state.flightDestinationRegion = action.payload.flightDestinationRegion;
      state.metaTags = action.payload.metaTags;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});

var stateSelector = function stateSelector(state) {
  return state[key];
};

var flightDestinationRegionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightDestinationRegion;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var initFlightDestination = lpFlightDstRegionSlice.actions.initFlightDestination;

var destinationTypeForSearch = function destinationTypeForSearch(flightCheapestRoundTrip) {
  return flightCheapestRoundTrip.destinationType.replace("destination_", "");
};
var originTypeForSearch = function originTypeForSearch(flightCheapestRoundTrip) {
  return flightCheapestRoundTrip.originType.replace("origin_", "");
};

/***/ }),

/***/ 48161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* binding */ fetchLpHotelDstRegions; },
/* harmony export */   "KD": function() { return /* binding */ numPerPageSelector; },
/* harmony export */   "RT": function() { return /* binding */ initHotelDestination; },
/* harmony export */   "VE": function() { return /* binding */ hotelDestinationRegionSelector; },
/* harmony export */   "_p": function() { return /* binding */ pageSelector; },
/* harmony export */   "jb": function() { return /* binding */ lpHotelDstRegionSlice; },
/* harmony export */   "rN": function() { return /* binding */ totalNumSelector; }
/* harmony export */ });
/* unused harmony exports fetchLpHotelDstRegionsShowPage, errorsSelector, loadingSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83119);






var key = "lpHotelDstRegion";
var initialState = {
  hotelDestinationRegion: null,
  metaTags: null,
  page: 0,
  numPerPage: 0,
  totalNum: 0,
  loading: false,
  errors: null
};
/** Async **/

var fetchLpHotelDstRegionsShowPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchLpHotelDstRegionsShowPage"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, id, param, _args$isServerSide, isServerSide, headers, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            id = args.id, param = args.param, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? false : _args$isServerSide, headers = args.headers;
            url = "/api/page/lp/hotels/dst_regions/".concat(id, ".json?").concat(param);
            _context.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 6:
            result = _context.sent;
            return _context.abrupt("return", {
              hotelDestinationRegion: result.data.hotelDestinationRegion,
              metaTags: result.data.metaTags,
              numPerPage: result.data.numPerPage,
              page: result.data.page,
              totalNum: result.data.totalNum
            });

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context.t0.response.data)));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var fetchLpHotelDstRegions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchLpHotelDstRegions"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, id, page, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            id = args.id, page = args.page;
            url = "/api/lp/hotels/dst_regions/".concat(id, ".json?page=").concat(page);
            _context2.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)().get(url);

          case 6:
            result = _context2.sent;
            return _context2.abrupt("return", {
              hotels: result.data.hotels,
              page: page
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context2.t0.response.data)));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
/** slice **/

var lpHotelDstRegionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initHotelDestination: function initHotelDestination(state, action) {
      state.hotelDestinationRegion = action.payload.hotelDestinationRegion;
      state.metaTags = action.payload.metaTags;
      state.numPerPage = action.payload.numPerPage;
      state.page = action.payload.page;
      state.totalNum = action.payload.totalNum;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchLpHotelDstRegions.fulfilled, function (state, action) {
      state.hotelDestinationRegion.hotels = action.payload.hotels;
      state.page = action.payload.page;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});

var stateSelector = function stateSelector(state) {
  return state[key];
};

var hotelDestinationRegionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelDestinationRegion;
});
var pageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.page;
});
var numPerPageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.numPerPage;
});
var totalNumSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.totalNum;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var initHotelDestination = lpHotelDstRegionSlice.actions.initHotelDestination;


/***/ }),

/***/ 52:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IZ": function() { return /* binding */ setLineRegisterUrl; },
/* harmony export */   "S3": function() { return /* binding */ lpSlice; },
/* harmony export */   "U_": function() { return /* binding */ lpContentSelector; },
/* harmony export */   "jz": function() { return /* binding */ initLpContent; },
/* harmony export */   "vt": function() { return /* binding */ lineRegisterUrlSelector; }
/* harmony export */ });
/* unused harmony exports fetchLpContent, errorsSelector, loadingSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22222);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);







var key = "lp";
var initialState = {
  lpContent: null,
  lineRegisterUrl: "",
  loading: false,
  errors: null
};
/** Async **/

var fetchLpContent = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchLpContent"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, cityPath, params, _args$isServerSide, isServerSide, headers, param, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            cityPath = args.cityPath, params = args.params, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? false : _args$isServerSide, headers = args.headers;
            param = (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(params), {
              arrayFormat: "brackets"
            });
            url = "/api/lps/".concat(cityPath, ".json?").concat(param);
            _context.next = 7;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 7:
            result = _context.sent;
            return _context.abrupt("return", {
              lpContent: result.data.lpContent
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/** slice **/

var lpSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initLpContent: function initLpContent(state, action) {
      state.lpContent = action.payload;
    },
    setLineRegisterUrl: function setLineRegisterUrl(state, action) {
      state.lineRegisterUrl = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchLpContent.fulfilled, function (state, action) {
      state.lpContent = action.payload.lpContent;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});

var stateSelector = function stateSelector(state) {
  return state[key];
};

var lpContentSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.lpContent;
});
var lineRegisterUrlSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.lineRegisterUrl;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var _lpSlice$actions = lpSlice.actions,
    initLpContent = _lpSlice$actions.initLpContent,
    setLineRegisterUrl = _lpSlice$actions.setLineRegisterUrl;


/***/ }),

/***/ 78121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ tagSelector; },
/* harmony export */   "KD": function() { return /* binding */ numPerPageSelector; },
/* harmony export */   "Pq": function() { return /* binding */ initPosts; },
/* harmony export */   "_p": function() { return /* binding */ pageSelector; },
/* harmony export */   "a7": function() { return /* binding */ rankingsSelector; },
/* harmony export */   "fq": function() { return /* binding */ popularTagsSelector; },
/* harmony export */   "h2": function() { return /* binding */ postSlice; },
/* harmony export */   "iF": function() { return /* binding */ initPost; },
/* harmony export */   "lK": function() { return /* binding */ putPostAccess; },
/* harmony export */   "pm": function() { return /* binding */ postSelector; },
/* harmony export */   "rN": function() { return /* binding */ totalNumSelector; },
/* harmony export */   "xE": function() { return /* binding */ postsSelector; },
/* harmony export */   "yq": function() { return /* binding */ regionSelector; }
/* harmony export */ });
/* unused harmony exports fetchPostsIndexPage, fetchPostsShowPage, postByIdSelector, postIdsSelector, postEntitiesSelector, totalPostsSelector, errorsSelector, loadingSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25968);







var key = "post";
var adapter = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createEntityAdapter */ .HF)();
var initialState = adapter.getInitialState({
  errors: null,
  post: null,
  postId: undefined,
  page: 0,
  numPerPage: 0,
  totalNum: 0,
  isLastPage: false,
  tag: null,
  region: null,
  rankings: [],
  popularTags: [],
  loading: false
});
/** Async **/

var fetchPostsIndexPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchPostsIndexPage"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, param, _args$isServerSide, isServerSide, headers, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            param = args.param, _args$isServerSide = args.isServerSide, isServerSide = _args$isServerSide === void 0 ? true : _args$isServerSide, headers = args.headers;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__/* .PATH_SCOPE */ .j1, "/api/page/posts.json?").concat(param);
            _context.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 6:
            result = _context.sent;
            return _context.abrupt("return", {
              posts: result.data.posts,
              totalNum: result.data.totalNum,
              page: result.data.page,
              numPerPage: result.data.numPerPage,
              tag: result.data.tag,
              rankings: result.data.rankings,
              popularTags: result.data.popularTags,
              region: result.data.region
            });

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context.t0.response.data)));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var fetchPostsShowPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchPostsShowPage"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, id, param, _args$isServerSide2, isServerSide, headers, url, result;

    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            id = args.id, param = args.param, _args$isServerSide2 = args.isServerSide, isServerSide = _args$isServerSide2 === void 0 ? true : _args$isServerSide2, headers = args.headers;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__/* .PATH_SCOPE */ .j1, "/api/page/posts/").concat(id, ".json?").concat(param);
            _context2.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)({
              isServerSide: isServerSide
            }).get(url, {
              headers: headers
            });

          case 6:
            result = _context2.sent;
            return _context2.abrupt("return", {
              post: result.data.post
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context2.t0.response.data)));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
var putPostAccess = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("".concat(key, "/putPostAccess"), /*#__PURE__*/function () {
  var _ref6 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(args, _ref5) {
    var rejectWithValue, id, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = _ref5.rejectWithValue;
            _context3.prev = 1;
            id = args.id;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__/* .PATH_SCOPE */ .j1, "/api/posts/").concat(id, "/access.json");
            _context3.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)().put(url);

          case 6:
            result = _context3.sent;
            return _context3.abrupt("return", {
              data: result.data
            });

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context3.t0.response.data)));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 10]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
/** slice **/

var postSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initPosts: function initPosts(state, action) {
      adapter.setAll(state, action.payload.posts);
      state.totalNum = action.payload.totalNum;
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
      state.tag = action.payload.tag;
      state.rankings = action.payload.rankings;
      state.popularTags = action.payload.popularTags;
      state.region = action.payload.region;
    },
    initPost: function initPost(state, action) {
      state.post = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchPostsIndexPage.fulfilled, function (state, action) {
      adapter.setAll(state, action.payload.posts);
      state.totalNum = action.payload.totalNum;
      state.page = action.payload.page;
      state.numPerPage = action.payload.numPerPage;
      state.tag = action.payload.tag;
      state.rankings = action.payload.rankings;
      state.popularTags = action.payload.popularTags;
      state.region = action.payload.region;
    }).addCase(fetchPostsShowPage.fulfilled, function (state, action) {
      state.post = action.payload.post;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var _adapter$getSelectors = adapter.getSelectors(function (state) {
  return state.post;
}),
    postByIdSelector = _adapter$getSelectors.selectById,
    postIdsSelector = _adapter$getSelectors.selectIds,
    postEntitiesSelector = _adapter$getSelectors.selectEntities,
    postsSelector = _adapter$getSelectors.selectAll,
    totalPostsSelector = _adapter$getSelectors.selectTotal;



var stateSelector = function stateSelector(state) {
  return state[key];
};

var postSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.post;
});
var totalNumSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.totalNum;
});
var pageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.page;
});
var numPerPageSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.numPerPage;
});
var regionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.region;
});
var rankingsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.rankings;
});
var popularTagsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.popularTags;
});
var tagSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.tag;
});
var errorsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.errors;
});
var loadingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.loading;
});
/** action export **/

var _postSlice$actions = postSlice.actions,
    initPosts = _postSlice$actions.initPosts,
    initPost = _postSlice$actions.initPost;


/***/ }),

/***/ 54231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ searchPageSlice; },
/* harmony export */   "el": function() { return /* binding */ searchCategorySelector; },
/* harmony export */   "xc": function() { return /* binding */ changeSearchCategory; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22222);
/* harmony import */ var main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80264);


var key = "searchPage";
var initialState = {
  searchCategory: main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_0__/* .searchCategories.hotel */ .M.hotel
};
/** slice **/

var searchPageSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    changeSearchCategory: function changeSearchCategory(state, action) {
      state.searchCategory = action.payload;
    }
  } // extraReducers: (builder) => {},

});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var searchCategorySelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.searchCategory;
});
/** action export **/

var changeSearchCategory = searchPageSlice.actions.changeSearchCategory;


/***/ }),

/***/ 12297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nv": function() { return /* binding */ fetchAccountParams; },
/* harmony export */   "bw": function() { return /* binding */ accountParamSlice; }
/* harmony export */ });
/* unused harmony exports utmSourceSelector, lineRegisterUrlSelector, lineTypeSelector, researchFlightLiffIdSelector, researchHotelLiffIdSelector, availableLineRegisterUrlSelector, availableFacebookMessengerRegisterUrlSelector */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22222);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83119);
/* harmony import */ var _localeSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55220);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);








var key = "accountParam";
var initialState = {
  utmSource: null,
  lineRegisterUrl: null,
  lineType: null,
  researchFlightLiffId: null,
  researchHotelLiffId: null,
  errors: null,
  loading: false
};
/** Async **/

var fetchAccountParams = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(key, "/fetchAccountParams"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, param, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            param = args.param;
            _context.next = 5;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_2__/* .createWrapper */ .K)().get("".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/account_params.json?").concat(param));

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result.data);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(_context.t0.response.data)));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/** slice **/

var accountParamSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchAccountParams.fulfilled, function (state, action) {
      state.utmSource = action.payload.utmSource;
      state.lineRegisterUrl = action.payload.lineRegisterUrl;
      state.lineType = action.payload.lineType;
      state.researchFlightLiffId = action.payload.researchFlightLiffId;
      state.researchHotelLiffId = action.payload.researchHotelLiffId;
    }) // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_3__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var utmSourceSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.utmSource;
});
var lineRegisterUrlSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.lineRegisterUrl;
});
var lineTypeSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.lineType;
});
var researchFlightLiffIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.researchFlightLiffId;
});
var researchHotelLiffIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.researchHotelLiffId;
});
var availableLineRegisterUrlSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)([utmSourceSelector, lineRegisterUrlSelector, _localeSlice__WEBPACK_IMPORTED_MODULE_4__/* .localeSelector */ .TN], function (utmSource, lineRegisterUrl, locale) {
  // 日本以外サポート外
  if (locale !== "ja") {
    return null;
  }

  if ((utmSource === "line" || !utmSource) && lineRegisterUrl) {
    return lineRegisterUrl;
  }

  return null;
});
var availableFacebookMessengerRegisterUrlSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)([utmSourceSelector], function (utmSource) {
  if (utmSource === "facebook") {
    return "https://m.me/tabitabi.official";
  }

  return null;
});

/***/ }),

/***/ 55220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TN": function() { return /* binding */ localeSelector; },
/* harmony export */   "xm": function() { return /* binding */ localeSlice; }
/* harmony export */ });
/* unused harmony export setLocale */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22222);

var key = "locale";
var initialState = {
  locale: "ja"
};
/** slice **/

var localeSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    setLocale: function setLocale(state, action) {
      state.locale = action.payload;
    }
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var localeSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.locale;
}); // action export

var setLocale = localeSlice.actions.setLocale;


/***/ }),

/***/ 9195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$W": function() { return /* binding */ hotelIndexParamToSearchFormValues; },
/* harmony export */   "Ai": function() { return /* binding */ initHotelIndexParam; },
/* harmony export */   "C3": function() { return /* binding */ hotelShowParamSelector; },
/* harmony export */   "Gn": function() { return /* binding */ paramSlice; },
/* harmony export */   "H9": function() { return /* binding */ flightIndexParamToAdvancedParam; },
/* harmony export */   "M0": function() { return /* binding */ shortOrigin; },
/* harmony export */   "N2": function() { return /* binding */ isFlightIndexParamSelectionMode; },
/* harmony export */   "OJ": function() { return /* binding */ hotelIndexParamSelector; },
/* harmony export */   "Qd": function() { return /* binding */ flightShowParamSelector; },
/* harmony export */   "Wc": function() { return /* binding */ shortDestination; },
/* harmony export */   "XI": function() { return /* binding */ flightIndexParamSelector; },
/* harmony export */   "Yn": function() { return /* binding */ hotelIndexParamToAdvancedParam; },
/* harmony export */   "aT": function() { return /* binding */ initFlightIndexParam; },
/* harmony export */   "aW": function() { return /* binding */ hotelIndexParamIsSelectionMode; },
/* harmony export */   "bV": function() { return /* binding */ hotelShowParamToApiQueryParam; },
/* harmony export */   "dR": function() { return /* binding */ isCacheIdExpired; },
/* harmony export */   "eK": function() { return /* binding */ itineraryCount; },
/* harmony export */   "g5": function() { return /* binding */ initFlightShowParam; },
/* harmony export */   "iT": function() { return /* binding */ hotelShowParamTotalNumberOfAdult; },
/* harmony export */   "kP": function() { return /* binding */ hotelIndexParamToUrlParam; },
/* harmony export */   "kj": function() { return /* binding */ hotelIndexParamTotalNumberOfAdult; },
/* harmony export */   "lJ": function() { return /* binding */ flightIndexParamToSearchFormValues; },
/* harmony export */   "lU": function() { return /* binding */ hotelShowParamToFormValues; },
/* harmony export */   "lg": function() { return /* binding */ hotelShowParamHotelRoomIdSelector; },
/* harmony export */   "nR": function() { return /* binding */ initHotelShowParam; },
/* harmony export */   "ne": function() { return /* binding */ hotelShowParamTotalNumberOfChildren; },
/* harmony export */   "o$": function() { return /* binding */ hotelIndexParamToParam; },
/* harmony export */   "o0": function() { return /* binding */ flightIndexParamToParam; },
/* harmony export */   "vx": function() { return /* binding */ flightIndexParamToUrlParam; },
/* harmony export */   "zJ": function() { return /* binding */ hotelShowParamHotelPlanIdSelector; },
/* harmony export */   "zP": function() { return /* binding */ hotelIndexParamTotalNumberOfChildren; }
/* harmony export */ });
/* unused harmony exports hotelShowParamToUrlParam, hotelShowParamToParam, hotelShowParamToGuestsParam, hotelShowParamIsSelectionMode, flightIndexParamToTravelersParam, isFlightShowParamSelectionMode */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95094);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22222);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45021);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var key = "param";
var initialState = {
  hotelIndexParam: null,
  hotelShowParam: null,
  flightIndexParam: null,
  flightShowParam: null
};
/** slice **/

var paramSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {
    initHotelIndexParam: function initHotelIndexParam(state, action) {
      state.hotelIndexParam = action.payload;
    },
    initHotelShowParam: function initHotelShowParam(state, action) {
      state.hotelShowParam = action.payload;
    },
    initFlightIndexParam: function initFlightIndexParam(state, action) {
      state.flightIndexParam = action.payload;
    },
    initFlightShowParam: function initFlightShowParam(state, action) {
      state.flightShowParam = action.payload;
    }
  } // extraReducers: (builder) => {},

});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var hotelIndexParamSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelIndexParam;
});
var hotelShowParamSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelShowParam;
});
var hotelShowParamHotelRoomIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelShowParam.hotelRoomId;
});
var hotelShowParamHotelPlanIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.hotelShowParam.hotelPlanId;
});
var flightIndexParamSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightIndexParam;
});
var flightShowParamSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(stateSelector, function (state) {
  return state.flightShowParam;
}); // HotelIndexParam

var hotelIndexParamToSearchFormValues = function hotelIndexParamToSearchFormValues(param) {
  var guestsParam = guestsToFormValues(param.guests);
  return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
    destination: param.destination,
    destinationId: param.destinationId,
    destinationType: param.destinationType,
    checkinDate: param.checkinDate,
    checkoutDate: param.checkoutDate,
    cacheId: param.cacheId,
    valid: param.valid,
    longitude: param.longitude,
    latitude: param.latitude,
    guests: guestsParam,
    numberOfRooms: guestsParam.length,
    searchType: param.searchType,
    dynamicPackageId: param.dynamicPackageId,
    searchGroupId: param.searchGroupId,
    lId: param.lId,
    qCId: param.qCId,
    dynamicPackagePreReservationId: param.dynamicPackagePreReservationId
  });
};

var guestsToFormValues = function guestsToFormValues(paramGuests) {
  var guests = paramGuests.length > 0 ? paramGuests.map(function (guest) {
    var _guest$agesOfChildren;

    return _objectSpread(_objectSpread({}, guest), {}, {
      agesOfChildren: (_guest$agesOfChildren = guest.agesOfChildren) === null || _guest$agesOfChildren === void 0 ? void 0 : _guest$agesOfChildren.map(function (age) {
        return {
          age: age
        };
      })
    });
  }) : [{
    numberOfAdult: 2,
    agesOfChildren: []
  }];
  return guests.map(function (guest) {
    var _guest$agesOfChildren2;

    return _objectSpread(_objectSpread({}, guest), {}, {
      numberOfChildren: ((_guest$agesOfChildren2 = guest.agesOfChildren) === null || _guest$agesOfChildren2 === void 0 ? void 0 : _guest$agesOfChildren2.length) > 0 ? guest.agesOfChildren.length : 0
    });
  });
};

var hotelIndexParamToUrlParam = function hotelIndexParamToUrlParam(param) {
  return (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(hotelIndexParamToParam(param), {
    arrayFormat: "indices"
  });
};
var hotelIndexParamToParam = function hotelIndexParamToParam(param) {
  var guestsParam = hotelIndexParamToGuestsParam(param);
  return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
    destination: param.destination,
    destinationId: param.destinationId,
    destinationType: param.destinationType,
    checkinDate: param.checkinDate,
    checkoutDate: param.checkoutDate,
    cacheId: param.cacheId,
    valid: param.valid,
    longitude: param.longitude,
    latitude: param.latitude,
    guests: guestsParam,
    numberOfRooms: guestsParam.length,
    searchType: param.searchType,
    dynamicPackageId: param.dynamicPackageId,
    searchGroupId: param.searchGroupId,
    lId: param.lId,
    qCId: param.qCId,
    dynamicPackagePreReservationId: param.dynamicPackagePreReservationId
  });
};
var hotelIndexParamToAdvancedParam = function hotelIndexParamToAdvancedParam(param) {
  var minPrice = isNaN(Number(param.minPrice)) ? param.minPrice : Number(param.minPrice);
  var maxPrice = isNaN(Number(param.maxPrice)) ? param.maxPrice : Number(param.maxPrice);
  return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
    minPrice: minPrice,
    maxPrice: maxPrice,
    minRating: param.minRating,
    rank: param.rank,
    sortBy: param.sortBy,
    bedCount: param.bedCount,
    bedSizeTypes: param.bedSizeTypes,
    mealType: param.mealType,
    viewType: param.viewType,
    descendingRegionIds: param.descendingRegionIds,
    lId: param.lId,
    qCId: param.qCId
  });
};

var hotelIndexParamToGuestsParam = function hotelIndexParamToGuestsParam(param) {
  var _param$guests;

  var guests = ((_param$guests = param.guests) === null || _param$guests === void 0 ? void 0 : _param$guests.length) > 0 ? param.guests : [{
    numberOfAdult: 2,
    agesOfChildren: []
  }];
  return guests.map(function (guest) {
    var _guest$agesOfChildren3;

    return _objectSpread(_objectSpread({}, guest), {}, {
      numberOfChildren: ((_guest$agesOfChildren3 = guest.agesOfChildren) === null || _guest$agesOfChildren3 === void 0 ? void 0 : _guest$agesOfChildren3.length) > 0 ? guest.agesOfChildren.length : 0
    });
  });
};

var hotelIndexParamTotalNumberOfAdult = function hotelIndexParamTotalNumberOfAdult(param) {
  var sum = 0;
  param.guests.forEach(function (guest) {
    sum += Number(guest.numberOfAdult);
  });
  return sum;
};
var hotelIndexParamTotalNumberOfChildren = function hotelIndexParamTotalNumberOfChildren(param) {
  var sum = 0;
  param.guests.forEach(function (guest) {
    sum += Number(guest.agesOfChildren ? guest.agesOfChildren.length : 0);
  });
  return sum;
};
var hotelIndexParamIsSelectionMode = function hotelIndexParamIsSelectionMode(param) {
  return !!param.lId;
}; // HotelShowParam

var hotelShowParamToFormValues = function hotelShowParamToFormValues(param) {
  var guestsParam = guestsToFormValues(param.guests);
  return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, param), {}, {
    guests: guestsParam,
    numberOfRooms: guestsParam.length
  }));
};
var hotelShowParamToUrlParam = function hotelShowParamToUrlParam(param) {
  return stringify(decamelizeKeys(hotelShowParamToParam(param)), {
    arrayFormat: "indices"
  });
};
var hotelShowParamToApiQueryParam = function hotelShowParamToApiQueryParam(param) {
  return (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(hotelShowParamToParam(param)), {
    arrayFormat: "brackets"
  });
};
var hotelShowParamToParam = function hotelShowParamToParam(param) {
  var guestsParam = hotelShowParamToGuestsParam(param);
  return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, param), {}, {
    guests: guestsParam,
    numberOfRooms: guestsParam.length
  }));
};
var hotelShowParamToGuestsParam = function hotelShowParamToGuestsParam(param) {
  var guests = param.guests.length > 0 ? param.guests : [{
    numberOfAdult: 2,
    agesOfChildren: []
  }];
  return guests.map(function (guest) {
    return _objectSpread(_objectSpread({}, guest), {}, {
      numberOfChildren: guest.agesOfChildren.length > 0 ? guest.agesOfChildren.length : 0
    });
  });
};
var hotelShowParamTotalNumberOfAdult = function hotelShowParamTotalNumberOfAdult(param) {
  var sum = 0;
  param.guests.forEach(function (guest) {
    sum += Number(guest.numberOfAdult);
  });
  return sum;
};
var hotelShowParamTotalNumberOfChildren = function hotelShowParamTotalNumberOfChildren(param) {
  var sum = 0;
  param.guests.forEach(function (guest) {
    sum += Number(guest.agesOfChildren ? guest.agesOfChildren.length : 0);
  });
  return sum;
};
var hotelShowParamIsSelectionMode = function hotelShowParamIsSelectionMode(param) {
  return !!param.lId;
}; // FlightIndexParam

var expirationSecond = 1800;
var flightIndexParamToSearchFormValues = function flightIndexParamToSearchFormValues(param) {
  var baseParam = {
    cacheId: param.cacheId,
    page: param.page,
    cabinClass: param.cabinClass,
    flightType: param.flightType,
    traveler: travelerToFormValues(param.traveler),
    searchType: param.searchType,
    dynamicPackageId: param.dynamicPackageId || null,
    searchGroupId: param.searchGroupId || null,
    lId: param.lId,
    qCId: param.qCId,
    dynamicPackagePreReservationId: param.dynamicPackagePreReservationId
  };

  if (param.baggageAlert) {
    baseParam["baggageAlert"] = param.baggageAlert;
  }

  switch (param.flightType) {
    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.oneWay */ .z.oneWay:
      return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, baseParam), {}, {
        departureDate: param.departureDate,
        destination: param.destination,
        destinationId: param.destinationId,
        destinationType: param.destinationType,
        origin: param.origin,
        originId: param.originId,
        originType: param.originType
      }));

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.roundTrip */ .z.roundTrip:
      return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, baseParam), {}, {
        departureDate: param.departureDate,
        returnDate: param.returnDate,
        destination: param.destination,
        destinationId: param.destinationId,
        destinationType: param.destinationType,
        origin: param.origin,
        originId: param.originId,
        originType: param.originType
      }));

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.multiCity */ .z.multiCity:
      return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, baseParam), {}, {
        itineraries: param.itineraries
      }));
  }

  return baseParam;
};

var travelerToFormValues = function travelerToFormValues(travelerParam) {
  if (travelerParam && travelerParam.agesOfChildren) {
    var _travelerParam$agesOf;

    var agesOfChildren = (_travelerParam$agesOf = travelerParam.agesOfChildren) === null || _travelerParam$agesOf === void 0 ? void 0 : _travelerParam$agesOf.map(function (age) {
      return {
        age: age
      };
    });
    return _objectSpread(_objectSpread({}, travelerParam), {}, {
      agesOfChildren: agesOfChildren,
      numberOfChildren: travelerParam.agesOfChildren.length > 0 ? travelerParam.agesOfChildren.length : 0
    });
  } else {
    return travelerParam;
  }
};

var flightIndexParamToParam = function flightIndexParamToParam(param) {
  var baseParam = {
    cacheId: param.cacheId,
    page: param.page,
    cabinClass: param.cabinClass,
    flightType: param.flightType,
    traveler: flightIndexParamToTravelersParam(param),
    searchType: param.searchType,
    dynamicPackageId: param.dynamicPackageId || null,
    searchGroupId: param.searchGroupId || null,
    lId: param.lId,
    qCId: param.qCId,
    dynamicPackagePreReservationId: param.dynamicPackagePreReservationId
  };

  if (param.baggageAlert) {
    baseParam["baggageAlert"] = param.baggageAlert;
  }

  switch (param.flightType) {
    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.oneWay */ .z.oneWay:
      return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, baseParam), {}, {
        departureDate: param.departureDate,
        destination: param.destination,
        destinationId: param.destinationId,
        destinationType: param.destinationType,
        origin: param.origin,
        originId: param.originId,
        originType: param.originType
      }));

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.roundTrip */ .z.roundTrip:
      return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, baseParam), {}, {
        departureDate: param.departureDate,
        returnDate: param.returnDate,
        destination: param.destination,
        destinationId: param.destinationId,
        destinationType: param.destinationType,
        origin: param.origin,
        originId: param.originId,
        originType: param.originType
      }));

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.multiCity */ .z.multiCity:
      return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(_objectSpread(_objectSpread({}, baseParam), {}, {
        itineraries: param.itineraries
      }));
  }

  return baseParam;
};
var flightIndexParamToTravelersParam = function flightIndexParamToTravelersParam(param) {
  if (param.traveler && param.traveler.agesOfChildren) {
    return _objectSpread(_objectSpread({}, param.traveler), {}, {
      numberOfChildren: param.traveler.agesOfChildren.length > 0 ? param.traveler.agesOfChildren.length : 0
    });
  } else {
    return param.traveler;
  }
};
var flightIndexParamToAdvancedParam = function flightIndexParamToAdvancedParam(param) {
  var initialDepartureHour = {
    from: 0,
    to: 24
  };
  return (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
    minPrice: param.minPrice,
    maxPrice: param.maxPrice,
    maxStop: param.maxStop,
    departureHour1: param.departureHour1 || initialDepartureHour,
    departureHour2: param.departureHour2 || initialDepartureHour,
    departureHour3: param.departureHour3 || initialDepartureHour,
    departureHour4: param.departureHour4 || initialDepartureHour,
    departureHour5: param.departureHour5 || initialDepartureHour,
    lastDepartureHour: param.lastDepartureHour || initialDepartureHour,
    lastArrivalHour: param.lastArrivalHour || initialDepartureHour,
    minLayover: param.minLayover,
    maxLayover: param.maxLayover,
    airlineCodes: param.airlineCodes,
    departureAirportCodes: param.departureAirportCodes,
    transitAirportCodes: param.transitAirportCodes,
    sortBy: param.sortBy,
    freeBaggageType: param.freeBaggageType,
    notUseLcc: param.notUseLcc,
    lId: param.lId,
    qCId: param.qCId
  });
};
var flightIndexParamToUrlParam = function flightIndexParamToUrlParam(param) {
  return (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)((0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)(flightIndexParamToParam(param)), {
    arrayFormat: "indices"
  });
};
var isCacheIdExpired = function isCacheIdExpired(cacheId) {
  var cacheTimeString = cacheId.split("-").pop();

  if (cacheTimeString) {
    var cacheTime = parseInt(cacheTimeString, 10);

    if ((cacheTime + expirationSecond) * 1000 < new Date().getTime()) {
      return true;
    }
  }

  return false;
};
var itineraryCount = function itineraryCount(param) {
  switch (param.flightType) {
    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.oneWay */ .z.oneWay:
      return 1;

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.roundTrip */ .z.roundTrip:
      return 2;

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.multiCity */ .z.multiCity:
      return param.itineraries.length;
  }

  return 1;
};

var toShortCityName = function toShortCityName(name) {
  return name.replace(/ \(.*$/, "");
};

var shortOrigin = function shortOrigin(param) {
  switch (param.flightType) {
    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.oneWay */ .z.oneWay:
      return toShortCityName(param.origin);

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.roundTrip */ .z.roundTrip:
      return toShortCityName(param.origin);

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.multiCity */ .z.multiCity:
      if (itineraryCount(param) > 0) {
        return toShortCityName(param.itineraries[0].destination);
      } else {
        return "";
      }

  }

  return "";
};
var shortDestination = function shortDestination(param) {
  switch (param.flightType) {
    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.oneWay */ .z.oneWay:
      return toShortCityName(param.destination);

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.roundTrip */ .z.roundTrip:
      return toShortCityName(param.destination);

    case _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_3__/* .FlightTypes.multiCity */ .z.multiCity:
      if (itineraryCount(param) > 0) {
        return toShortCityName(param.itineraries[itineraryCount(param) - 1].destination);
      } else {
        return "";
      }

  }

  return "";
};
var isFlightIndexParamSelectionMode = function isFlightIndexParamSelectionMode(param) {
  return !!param.lId;
}; // FlightShowParam

var isFlightShowParamSelectionMode = function isFlightShowParamSelectionMode(param) {
  return !!param.lId;
};
/** action export **/

var _paramSlice$actions = paramSlice.actions,
    initHotelIndexParam = _paramSlice$actions.initHotelIndexParam,
    initHotelShowParam = _paramSlice$actions.initHotelShowParam,
    initFlightIndexParam = _paramSlice$actions.initFlightIndexParam,
    initFlightShowParam = _paramSlice$actions.initFlightShowParam;


/***/ }),

/***/ 62394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ store; },
  "TL": function() { return /* binding */ useAppDispatch; },
  "CG": function() { return /* binding */ useAppSelector; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(94500);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/node_modules/redux/es/redux.js
var redux = __webpack_require__(83105);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(22222);
// EXTERNAL MODULE: ./main/javascripts/utils/sliceUtil.ts
var sliceUtil = __webpack_require__(83119);
// EXTERNAL MODULE: ./main/javascripts/slices/accountParamSlice.ts
var accountParamSlice = __webpack_require__(12297);
// EXTERNAL MODULE: ./main/javascripts/features/emailUser/emailUserSlice.ts
var emailUserSlice = __webpack_require__(79283);
;// CONCATENATED MODULE: ./main/javascripts/slices/currentUserSlice.ts
 // import { createWrapper } from "main/javascripts/api/AxiosWrapper";
// import { ErrorResponse } from "main/javascripts/types/errorResponse";




var key = "currentUser";
var adapter = (0,redux_toolkit_esm/* createEntityAdapter */.HF)();
var initialState = adapter.getInitialState({
  currentUser: null,
  errors: null,
  loading: false
});
/** Async **/

/** slice **/

var currentUserSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: key,
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(accountParamSlice/* fetchAccountParams.fulfilled */.Nv.fulfilled, function (state, action) {
      state.currentUser = action.payload.currentUser;
    }).addCase(emailUserSlice/* authEmailChatUnit.fulfilled */.EL.fulfilled, function (state, action) {
      state.currentUser = action.payload.user;
    }) // 一旦slice単位で共通化
    .addMatcher((0,sliceUtil/* isPendingAction */.zY)(key), function (state) {
      state.loading = true;
    }).addMatcher((0,sliceUtil/* isFulfilledAction */.ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,sliceUtil/* isRejectedAction */._)(key), function (state) {
      // state.errors = action.payload;
      state.loading = false;
    });
  }
});
/** selector **/

var stateSelector = function stateSelector(state) {
  return state[key];
};

var currentUserSelector = (0,reselect_es/* createSelector */.P1)(stateSelector, function (state) {
  return state.currentUser;
});
// EXTERNAL MODULE: ./main/javascripts/features/cms/cmsSlice.ts
var cmsSlice = __webpack_require__(94737);
// EXTERNAL MODULE: ./main/javascripts/features/post/postSlice.ts
var postSlice = __webpack_require__(78121);
// EXTERNAL MODULE: ./main/javascripts/slices/localeSlice.ts
var localeSlice = __webpack_require__(55220);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/searchHotelSlice.ts
var searchHotelSlice = __webpack_require__(9296);
// EXTERNAL MODULE: ./main/javascripts/features/flight/searchFlightSlice.ts + 1 modules
var searchFlightSlice = __webpack_require__(71900);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/hotelSuggestionSlice.ts
var hotelSuggestionSlice = __webpack_require__(86058);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSuggestionSlice.ts
var flightSuggestionSlice = __webpack_require__(59960);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/hotelSlice.ts
var hotelSlice = __webpack_require__(74659);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSlice.ts
var flightSlice = __webpack_require__(55030);
// EXTERNAL MODULE: ./main/javascripts/features/search/searchPageSlice.ts
var searchPageSlice = __webpack_require__(54231);
// EXTERNAL MODULE: ./main/javascripts/slices/paramSlice.ts
var paramSlice = __webpack_require__(9195);
// EXTERNAL MODULE: ./main/javascripts/features/lp/lpSlice.ts
var lpSlice = __webpack_require__(52);
// EXTERNAL MODULE: ./main/javascripts/features/lp/hotelDstRegion/lpHotelDstRegionSlice.ts
var lpHotelDstRegionSlice = __webpack_require__(48161);
// EXTERNAL MODULE: ./main/javascripts/features/lp/flightDstRegion/lpFlightDstRegionSlice.ts
var lpFlightDstRegionSlice = __webpack_require__(95698);
// EXTERNAL MODULE: ./main/javascripts/reducers/HotelReducer.ts
var HotelReducer = __webpack_require__(68118);
// EXTERNAL MODULE: ./main/javascripts/reducers/RestaurantReducer.ts
var RestaurantReducer = __webpack_require__(84012);
// EXTERNAL MODULE: ./main/javascripts/reducers/ActivityReducer.ts
var ActivityReducer = __webpack_require__(11904);
// EXTERNAL MODULE: ./main/javascripts/reducers/DestinationSuggestReducer.ts
var DestinationSuggestReducer = __webpack_require__(80427);
// EXTERNAL MODULE: ./main/javascripts/reducers/ParamReducer.ts + 3 modules
var ParamReducer = __webpack_require__(14978);
// EXTERNAL MODULE: ./main/javascripts/reducers/AccountParamsReducer.ts
var AccountParamsReducer = __webpack_require__(29886);
// EXTERNAL MODULE: ./main/javascripts/reducers/HotelReservationReducer.ts + 1 modules
var HotelReservationReducer = __webpack_require__(26421);
// EXTERNAL MODULE: ./main/javascripts/reducers/FlightReservationReducer.ts + 1 modules
var FlightReservationReducer = __webpack_require__(16113);
// EXTERNAL MODULE: ./main/javascripts/reducers/ReservationReducer.ts
var ReservationReducer = __webpack_require__(54271);
// EXTERNAL MODULE: ./main/javascripts/reducers/HotelPreReservationReducer.ts
var HotelPreReservationReducer = __webpack_require__(56329);
// EXTERNAL MODULE: ./main/javascripts/reducers/FlightPreReservationReducer.ts
var FlightPreReservationReducer = __webpack_require__(16973);
// EXTERNAL MODULE: ./main/javascripts/reducers/CurrentUserReducer.ts
var CurrentUserReducer = __webpack_require__(26439);
// EXTERNAL MODULE: ./main/javascripts/reducers/RequestReducer.ts
var RequestReducer = __webpack_require__(9058);
// EXTERNAL MODULE: ./main/javascripts/reducers/SearchPageReducer.ts + 1 modules
var SearchPageReducer = __webpack_require__(67672);
// EXTERNAL MODULE: ./main/javascripts/reducers/FlightOriginDestinationSuggestReducer.ts + 1 modules
var FlightOriginDestinationSuggestReducer = __webpack_require__(1089);
// EXTERNAL MODULE: ./main/javascripts/reducers/FlightReducer.ts
var FlightReducer = __webpack_require__(41386);
// EXTERNAL MODULE: ./main/javascripts/reducers/BreakpointReducer.ts
var BreakpointReducer = __webpack_require__(46489);
// EXTERNAL MODULE: ./main/javascripts/reducers/CountryReducer.ts
var CountryReducer = __webpack_require__(37315);
// EXTERNAL MODULE: ./main/javascripts/reducers/LocaleReducer.ts + 1 modules
var LocaleReducer = __webpack_require__(95287);
// EXTERNAL MODULE: ./main/javascripts/reducers/DynamicPackagePreReservationReducer.ts
var DynamicPackagePreReservationReducer = __webpack_require__(95956);
// EXTERNAL MODULE: ./main/javascripts/reducers/DynamicPackageReservationReducer.ts + 1 modules
var DynamicPackageReservationReducer = __webpack_require__(67632);
// EXTERNAL MODULE: ./main/javascripts/reducers/CarouselFlightReducer.ts + 1 modules
var CarouselFlightReducer = __webpack_require__(69838);
// EXTERNAL MODULE: ./main/javascripts/reducers/ConsultationConditionReducer.ts + 2 modules
var ConsultationConditionReducer = __webpack_require__(27828);
// EXTERNAL MODULE: ./main/javascripts/reducers/ConsultationReducer.ts + 1 modules
var ConsultationReducer = __webpack_require__(41402);
// EXTERNAL MODULE: ./main/javascripts/reducers/SearchFlightReducer.ts + 1 modules
var SearchFlightReducer = __webpack_require__(57897);
// EXTERNAL MODULE: ./main/javascripts/reducers/SearchHotelReducer.ts + 1 modules
var SearchHotelReducer = __webpack_require__(69145);
// EXTERNAL MODULE: ./main/javascripts/reducers/SocialMediaStatusReducer.ts
var SocialMediaStatusReducer = __webpack_require__(90281);
// EXTERNAL MODULE: ./main/javascripts/reducers/ConstantReducer.ts
var ConstantReducer = __webpack_require__(31296);
// EXTERNAL MODULE: ./main/javascripts/reducers/MessageReducer.ts
var MessageReducer = __webpack_require__(1382);
// EXTERNAL MODULE: ./main/javascripts/reducers/PostReducer.ts
var PostReducer = __webpack_require__(16370);
// EXTERNAL MODULE: ./main/javascripts/reducers/EditorReducer.ts
var EditorReducer = __webpack_require__(64383);
// EXTERNAL MODULE: ./main/javascripts/reducers/RegionReducer.ts + 1 modules
var RegionReducer = __webpack_require__(36126);
// EXTERNAL MODULE: ./main/javascripts/reducers/ChargeInfoReducer.ts + 1 modules
var ChargeInfoReducer = __webpack_require__(36612);
;// CONCATENATED MODULE: ./main/javascripts/rootReducer.ts
















 //


































var rootReducer = {
  currentUser: currentUserSlice.reducer,
  accountParam: accountParamSlice/* accountParamSlice.reducer */.bw.reducer,
  cms: cmsSlice/* cmsSlice.reducer */.ON.reducer,
  post: postSlice/* postSlice.reducer */.h2.reducer,
  locale: localeSlice/* localeSlice.reducer */.xm.reducer,
  searchHotel: searchHotelSlice/* searchHotelSlice.reducer */.Rd.reducer,
  searchFlight: searchFlightSlice/* searchFlightSlice.reducer */.ID.reducer,
  hotelSuggestion: hotelSuggestionSlice/* hotelSuggestionSlice.reducer */.tj.reducer,
  flightSuggestion: flightSuggestionSlice/* flightSuggestionSlice.reducer */.UD.reducer,
  hotel: hotelSlice/* hotelSlice.reducer */.GP.reducer,
  flight: flightSlice/* flightSlice.reducer */.o4.reducer,
  searchPage: searchPageSlice/* searchPageSlice.reducer */.EC.reducer,
  param: paramSlice/* paramSlice.reducer */.Gn.reducer,
  lp: lpSlice/* lpSlice.reducer */.S3.reducer,
  lpHotelDstRegion: lpHotelDstRegionSlice/* lpHotelDstRegionSlice.reducer */.jb.reducer,
  lpFlightDstRegion: lpFlightDstRegionSlice/* lpFlightDstRegionSlice.reducer */.pU.reducer,
  emailUser: emailUserSlice/* emailUserSlice.reducer */.lJ.reducer,
  hotelReducer: HotelReducer/* hotelReducer */.g,
  restaurantReducer: RestaurantReducer/* restaurantReducer */.J,
  activityReducer: ActivityReducer/* activityReducer */.J,
  paramReducer: ParamReducer/* paramReducer */.q,
  accountParamsReducer: AccountParamsReducer/* accountParamsReducer */.D,
  destinationSuggestReducer: DestinationSuggestReducer/* destinationSuggestReducer */.i,
  hotelReservationReducer: HotelReservationReducer/* hotelReservationReducer */.S,
  hotelPreReservationReducer: HotelPreReservationReducer/* hotelPreReservationReducer */.a,
  flightPreReservationReducer: FlightPreReservationReducer/* flightPreReservationReducer */.t,
  flightReservationReducer: FlightReservationReducer/* flightReservationReducer */.b,
  reservationReducer: ReservationReducer/* reservationReducer */.O,
  currentUserReducer: CurrentUserReducer/* currentUserReducer */.r,
  requestReducer: RequestReducer/* requestReducer */.w,
  searchPageReducer: SearchPageReducer/* searchPageReducer */.Y,
  flightOriginDestinationSuggestReducer: FlightOriginDestinationSuggestReducer/* flightOriginDestinationSuggestReducer */.w,
  flightReducer: FlightReducer/* flightReducer */.Y,
  breakpointReducer: BreakpointReducer/* breakpointReducer */.a,
  countryReducer: CountryReducer/* countryReducer */.J,
  localeReducer: LocaleReducer/* localeReducer */.C,
  dynamicPackagePreReservationReducer: DynamicPackagePreReservationReducer/* dynamicPackagePreReservationReducer */._,
  dynamicPackageReservationReducer: DynamicPackageReservationReducer/* dynamicPackageReservationReducer */.L,
  carouselFlightReducer: CarouselFlightReducer/* carouselFlightReducer */.m,
  consultationConditionReducer: ConsultationConditionReducer/* consultationConditionReducer */.R,
  consultationReducer: ConsultationReducer/* consultationReducer */.K,
  searchFlightReducer: SearchFlightReducer/* searchFlightReducer */.z,
  searchHotelReducer: SearchHotelReducer/* searchHotelReducer */.n,
  socialMediaStatusReducer: SocialMediaStatusReducer/* socialMediaStatusReducer */.l,
  constantReducer: ConstantReducer/* constantReducer */.H,
  messageReducer: MessageReducer/* messageReducer */.C,
  postReducer: PostReducer/* postReducer */.s,
  editorReducer: EditorReducer/* editorReducer */.C,
  regionReducer: RegionReducer/* regionReducer */.G,
  chargeInfoReducer: ChargeInfoReducer/* chargeInfoReducer */.y
};
// EXTERNAL MODULE: ./main/javascripts/middleware/normalizrMiddleware.ts
var normalizrMiddleware = __webpack_require__(78362);
// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 3 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(81437);
// EXTERNAL MODULE: ./main/javascripts/sagas/index.ts + 11 modules
var sagas = __webpack_require__(13855);
;// CONCATENATED MODULE: ./main/javascripts/store.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // import { createWrapper } from "next-redux-wrapper";






var store_rootReducer = (0,redux/* combineReducers */.UY)(_objectSpread({}, rootReducer));
var normalizr = (0,normalizrMiddleware/* normalizrMiddleware */.U)();
var sagaMiddleware = (0,redux_saga_core_npm_proxy_esm/* default */.ZP)(); // loggerにMiddleware型を指定しないとdispatch時に型エラーが発生する

var createStore = function createStore() {
  return (0,redux_toolkit_esm/* configureStore */.xC)({
    reducer: store_rootReducer,
    // 完全にredux toolkitに移行できたらnormalizrを削除する
    // TODO: RTKに完全移行した後serializableCheckとimmutableCheckの設定を削除する
    middleware: function middleware(getDefaultMiddleware) {
      return  true ? getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false
      }).concat([normalizr, sagaMiddleware]) : 0;
    }
  });
};

var store = createStore();
sagaMiddleware.run(sagas/* default */.Z);
var useAppDispatch = function useAppDispatch() {
  return (0,es/* useDispatch */.I0)();
};
var useAppSelector = es/* useSelector */.v9; // export const wrapper = createWrapper<AppStore>(createStore);

/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ borderRadius; }
/* harmony export */ });
var borderRadius = {
  normal: "4px",
  message: "12px"
};

/***/ }),

/***/ 78698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ boxShadow; }
/* harmony export */ });
var boxShadow = {
  "interface": "0 3px 12px rgba(0,0,0,0.06)"
};

/***/ }),

/***/ 15305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UH": function() { return /* binding */ GLOBALS; },
/* harmony export */   "bU": function() { return /* binding */ extended; },
/* harmony export */   "jF": function() { return /* binding */ defaultStyles; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var aphrodite_no_important__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54170);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88433);



var GLOBALS = "__GLOBAL_STYLES__";
var globalExtension = {
  selectorHandler: function selectorHandler(selector, baseSelector, generateSubtreeStyles) {
    return baseSelector.includes(GLOBALS) ? generateSubtreeStyles(selector) : null;
  }
};
var extended = aphrodite_no_important__WEBPACK_IMPORTED_MODULE_0__.StyleSheet.extend([globalExtension]); // productionでclass nameがminifyされるとGLOBALSを付与せずバグるので、falseにする

extended.minify(false);
var defaultStyles = extended.StyleSheet.create((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, GLOBALS, {
  "*": {
    margin: "0px",
    padding: "0px"
  },
  html: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontSize: "100%",
    boxSizing: "border-box"
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_1__/* .moreThanBreakpoint */ .h6)("desktop"), {
    fontSize: "93.75%"
  }),
  body: {
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
    backgroundColor: "#fff",
    "-webkit-text-size-adjust": "100%"
  },
  "*::-webkit-input-placeholder": {
    color: "#aaa",
    lineHeight: "1.2"
  },
  hr: {
    display: "block",
    height: "1px",
    border: 0,
    borderTop: "1px solid #ccc",
    margin: "1em 0",
    padding: 0
  },
  ul: {
    paddingLeft: "1.3em",
    listStyle: "square"
  }
}));

/***/ }),

/***/ 16341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ parseDate; }
/* harmony export */ });
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23855);

function parseDate(date) {
  var newDate = date;

  if (typeof newDate === "string") {
    newDate = newDate.replace(/\//g, "-");
    return (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_0__["default"])(newDate);
  }

  return newDate;
}

/***/ }),

/***/ 56896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ url2link; },
/* harmony export */   "Vh": function() { return /* binding */ zeroFill; },
/* harmony export */   "dl": function() { return /* binding */ br2nl; },
/* harmony export */   "fe": function() { return /* binding */ numberToCurrency; },
/* harmony export */   "hU": function() { return /* binding */ nl2br; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);


function nl2br(text) {
  if (!text) {
    return text;
  }

  var regex = /(\n)/g;
  return text.split(regex).map(function (line, index) {
    if (line.match(regex)) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("br", {}, index);
    }

    return line;
  });
}
function br2nl(text) {
  if (!text) {
    return text;
  }

  return text.replace(/<br\s*\/?>/gm, "\n");
}
function zeroFill(num, length) {
  // tslint:disable-next-line:prefer-array-literal
  return "".concat(Array(length).join("0")).concat(num).slice(-length);
}
function numberToCurrency(num, currency) {
  var currencyDisplay = currency === "JPY" ? "name" : "symbol";
  return new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: currency,
    currencyDisplay: currencyDisplay
  }).format(num);
}
function url2link(text) {
  if (typeof text !== "string") {
    return text;
  }

  var regex = /(https?:\/\/.+)/;
  return text.split(regex).map(function (line, index) {
    var url = line.match(regex);

    if (url && url[1]) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("a", {
        href: url[1],
        rel: "nofollow noreferrer noopener",
        target: "_blank",
        children: url[1]
      }, index);
    }

    return line;
  });
}

/***/ }),

/***/ 48207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getUtmValues; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _cookieUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getUtmValues = function getUtmValues() {
  var utmCampaign = (0,_cookieUtil__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .e)("utm_campaign");
  var utmMedium = (0,_cookieUtil__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .e)("utm_medium");
  var utmSource = (0,_cookieUtil__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .e)("utm_source");

  var values = _objectSpread(_objectSpread(_objectSpread({}, utmCampaign && {
    utmCampaign: utmCampaign
  }), utmMedium && {
    utmMedium: utmMedium
  }), utmSource && {
    utmSource: utmSource
  });

  return (0,humps__WEBPACK_IMPORTED_MODULE_1__.decamelizeKeys)(values);
};

/***/ }),

/***/ 83119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ createDeepEqualSelector; },
/* harmony export */   "YD": function() { return /* binding */ debounced; },
/* harmony export */   "_": function() { return /* binding */ isRejectedAction; },
/* harmony export */   "ux": function() { return /* binding */ isFulfilledAction; },
/* harmony export */   "zY": function() { return /* binding */ isPendingAction; }
/* harmony export */ });
/* harmony import */ var underscore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36005);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22222);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44815);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_1__);



function isPendingAction(key) {
  return function (action) {
    return new RegExp("".concat(key, "/.+/pending")).test(action.type);
  };
}
function isRejectedAction(key) {
  return function (action) {
    return new RegExp("".concat(key, "/.+/rejected")).test(action.type);
  };
}
function isFulfilledAction(key) {
  return function (action) {
    return new RegExp("".concat(key, "/.+/fulfilled")).test(action.type);
  };
} // debounceを直接返す必要があるためwaitを変数化できない
// 異なる間隔が必要な場合別途定義する

var debounced = (0,underscore__WEBPACK_IMPORTED_MODULE_0__/* .debounce */ .Ds)(function (action, arg, dispatch) {
  return dispatch(action(arg));
}, 300);
var createDeepEqualSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelectorCreator */ .wN)(reselect__WEBPACK_IMPORTED_MODULE_3__/* .defaultMemoize */ .PW, (react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default()));

/***/ }),

/***/ 11166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D$": function() { return /* binding */ objectToFormData; },
/* harmony export */   "HO": function() { return /* binding */ removeEmpty; },
/* harmony export */   "d9": function() { return /* binding */ clone; },
/* harmony export */   "nK": function() { return /* binding */ isObjectEmpty; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16835);

function isObjectEmpty(object) {
  return Object.keys(object).length === 0;
}
function objectToFormData(obj, form, namespace) {
  var arrayFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "indices";
  var fd = form || new FormData();
  var formKey;

  if (!obj) {
    return fd;
  }

  Object.keys(obj).forEach(function (property) {
    if (Object.hasOwnProperty.call(obj, property)) {
      if (namespace) {
        formKey = "".concat(namespace, "[").concat(property, "]");
      } else {
        formKey = property;
      }

      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (obj[property] instanceof Array) {
        obj[property].forEach(function (element, index) {
          var tempFormKey = arrayFormat === "brackets" ? "".concat(formKey, "[]") : "".concat(formKey, "[").concat(index, "]");

          if (typeof element === "object" && !(element instanceof File)) {
            objectToFormData(element, fd, tempFormKey);
          } else {
            fd.append(tempFormKey, element);
          }
        });
      } else if (typeof obj[property] === "object" && !(obj[property] instanceof File)) {
        objectToFormData(obj[property], fd, formKey);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  });
  return fd;
}
function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
    var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, 2),
        _ = _ref2[0],
        v = _ref2[1];

    return v != null && v != "";
  }));
}

/***/ })

}]);